import {
  useSearchConditionFavorite
} from "./chunk-TDHJP36P.mjs";
import {
  DndRow
} from "./chunk-BWBPOHUG.mjs";
import {
  Draggable
} from "./chunk-5MXOOKCL.mjs";
import {
  NoDataFiller
} from "./chunk-E5TZBQVL.mjs";
import {
  initCurrentSearchConditionItem,
  inputValueToString
} from "./chunk-2HDQ2NJK.mjs";
import {
  ActionType
} from "./chunk-SWO6SUCI.mjs";
import {
  BaseDialog
} from "./chunk-UUR2JKO2.mjs";
import {
  ModalFrame
} from "./chunk-KOQJG44Q.mjs";
import {
  getFormClassName
} from "./chunk-3KDSPTP2.mjs";
import {
  Required
} from "./chunk-ZKGUBEB4.mjs";
import {
  Form
} from "./chunk-KWWGA76Y.mjs";
import {
  BaseRangePicker
} from "./chunk-ZJPEQDBE.mjs";
import {
  BaseSinglePicker,
  INPUT_ATTRIBUTES
} from "./chunk-UAKZWEFY.mjs";
import {
  OutsideClickHandler
} from "./chunk-BORAXMZU.mjs";
import {
  ExpandIcon,
  Icon
} from "./chunk-WRVJKWCY.mjs";
import {
  matchLoading
} from "./chunk-BTYWWCZT.mjs";
import {
  Tooltips
} from "./chunk-TZ7NDB2R.mjs";
import {
  AscendPopupContainerId,
  PopupPortal
} from "./chunk-UZDY5GA7.mjs";
import {
  Colors
} from "./chunk-RPWVFA4F.mjs";
import {
  Typography
} from "./chunk-NE6DZMQA.mjs";
import {
  useHover
} from "./chunk-EVE3IGZR.mjs";
import {
  useKey
} from "./chunk-I754SZEB.mjs";
import {
  DateUtils,
  LocalDate,
  LocalDateTime,
  LocalTime,
  StringUtils,
  YearMonth,
  isNonNullable,
  isNullable,
  isString,
  isStringArray,
  matchType
} from "./chunk-ARWLRO3D.mjs";

// lib/components/button/base-button.tsx
import classNames10 from "classnames";
import { forwardRef as forwardRef7, useState as useState11 } from "react";

// lib/components/button/button/button.tsx
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx } from "@emotion/react/jsx-runtime";
var Button = forwardRef(
  ({ isSmall = false, isWide = false, className, style, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      BaseButton,
      {
        ...props,
        ref,
        className: classNames(isSmall && "is-small", className),
        style: {
          ...style,
          minWidth: isWide ? 160 : style?.minWidth
        }
      }
    );
  }
);
Button.displayName = "Button";

// lib/components/button/submit-button/submit-button.tsx
import classNames2 from "classnames";
import { forwardRef as forwardRef2 } from "react";
import { Fragment, jsx as jsx2, jsxs } from "@emotion/react/jsx-runtime";
var SubmitButton = forwardRef2(
  ({
    loading,
    disabled = false,
    denied,
    deniedMessage,
    className,
    children,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx2(Fragment, { children: /* @__PURE__ */ jsxs(
      Button,
      {
        ref,
        ...props,
        className: classNames2(
          className,
          matchLoading(loading, {
            idle: "",
            loading: "is-loading",
            success: "",
            failure: "is-danger"
          })
        ),
        disabled: disabled || denied || loading === "loading",
        children: [
          children,
          /* @__PURE__ */ jsx2(DeniedByPolicyIcon, { denied, deniedMessage })
        ]
      }
    ) });
  }
);
SubmitButton.displayName = "SubmitButton";

// lib/components/checkbox/check-cell/check-cell.tsx
import { useState } from "react";
import { jsx as jsx3, jsxs as jsxs2 } from "@emotion/react/jsx-runtime";
var CheckCell = ({ As, tips, ...props }) => {
  const { hovering, hoverSensor } = useHover();
  const [ref, setRef] = useState(null);
  return /* @__PURE__ */ jsxs2(
    As,
    {
      style: {
        padding: 0,
        textAlign: "center",
        verticalAlign: "middle",
        width: 20,
        height: "100%"
      },
      onClick: (e2) => {
        e2.stopPropagation();
      },
      children: [
        /* @__PURE__ */ jsx3(
          "label",
          {
            className: "py-2 is-clickable",
            style: {
              display: "block",
              height: "100%",
              width: "100%",
              position: "relative"
            },
            children: /* @__PURE__ */ jsx3(
              "input",
              {
                type: "checkbox",
                className: "is-clickable",
                ...props,
                style: {
                  ...props.style,
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translateY(-50%) translateX(-50%)"
                },
                ...hoverSensor,
                ref: setRef
              }
            )
          }
        ),
        tips && /* @__PURE__ */ jsx3(Tooltips, { isActive: hovering, refElement: ref, ...tips })
      ]
    }
  );
};

// lib/components/combined/search-input/search-input.tsx
import { css as css2 } from "@emotion/react";
import { useState as useState2 } from "react";

// lib/components/form-chip/form-chip-input-selector/components/text-input/text-input.tsx
import { css } from "@emotion/react";
import { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { jsx as jsx4 } from "@emotion/react/jsx-runtime";
var TextInput = ({
  className,
  name,
  value,
  placeholder = "\u5165\u529B\u3059\u308B",
  onChange
}) => {
  const { register, setValue } = useFormContext();
  const reg = useMemo(() => register(name), [name, register]);
  useEffect(() => setValue(name, value), [name, setValue, value]);
  return /* @__PURE__ */ jsx4(
    "input",
    {
      ...reg,
      className,
      css: css`
        ${Typography.InputValue}
        color: ${Colors.Gray100};
        width: auto;
        max-width: 120px;
        min-width: 48px;
        padding: 0.33em;
        outline: none;
        border: 0;
        ::placeholder {
          color: ${Colors.Gray30};
        }
      `,
      type: "text",
      value,
      placeholder,
      onChange: (e2) => {
        reg.onChange(e2);
        if (onChange) onChange(e2.target.value);
      }
    }
  );
};

// lib/components/combined/search-input/search-input.tsx
import { jsx as jsx5, jsxs as jsxs3 } from "@emotion/react/jsx-runtime";
var SearchInput = ({
  className,
  name,
  buttonTitle = "\u691C\u7D22",
  onChange,
  onSubmit
}) => {
  const [value, setValue] = useState2("");
  return /* @__PURE__ */ jsxs3(
    "div",
    {
      css: css2`
        display: flex;
        border: 1px solid ${Colors.Gray20};
        border-radius: 4px;
      `,
      className,
      children: [
        /* @__PURE__ */ jsx5(
          TextInput,
          {
            css: css2`
          ${Typography.Default}
          width: 6em;
          padding: 4px;
          outline: none;
          border: none;
          border-right: 1px solid ${Colors.Gray20};
          border-radius: 0;
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
        `,
            name,
            value,
            onChange: (v2) => {
              setValue(v2);
              onChange && onChange(value);
            }
          }
        ),
        /* @__PURE__ */ jsx5(
          Button,
          {
            css: css2`
          border: none;
          border-radius: 0;
          border-top-right-radius: 3px;
          border-bottom-right-radius: 3px;
        `,
            onSubmit: () => {
              onSubmit && onSubmit(value);
            },
            children: buttonTitle
          }
        )
      ]
    }
  );
};

// lib/components/date-picker/base/base-expandable-range-picker.tsx
import { useEffect as useEffect2, useState as useState3 } from "react";
import { Fragment as Fragment2, jsx as jsx6, jsxs as jsxs4 } from "@emotion/react/jsx-runtime";
var BaseExpandableRangePicker = ({
  value,
  onChange,
  onBlur,
  left,
  right,
  autoFix,
  ...props
}) => {
  const isRange = (value?.start ? props.convert(value?.start) : "") !== (value?.end ? props.convert(value?.end) : "");
  const [expanding, setExpanding] = useState3(isRange);
  useEffect2(() => {
    isRange && setExpanding(true);
  }, [isRange]);
  return /* @__PURE__ */ jsx6(Fragment2, { children: !expanding ? /* @__PURE__ */ jsxs4("div", { className: "field has-addons", children: [
    left,
    /* @__PURE__ */ jsx6("div", { className: "control", children: /* @__PURE__ */ jsx6(
      BaseSinglePicker,
      {
        value: value?.start,
        ...props,
        onChange: (v2, e2) => {
          onChange?.({ start: v2, end: v2 }, e2);
        },
        onBlur: (v2, e2) => {
          onBlur?.({ start: v2, end: v2 }, e2);
        }
      }
    ) }),
    /* @__PURE__ */ jsx6("div", { className: "control", children: /* @__PURE__ */ jsx6(
      Button,
      {
        style: {
          backgroundColor: "#F2F3F4"
        },
        isSmall: props.isSmall,
        disabled: props.disabled,
        onClick: (e2) => {
          setExpanding(true);
          onBlur?.(value ?? {}, e2);
        },
        tips: { label: "\u671F\u9593\u3092\u5165\u529B\u3059\u308B" },
        children: /* @__PURE__ */ jsx6("span", { className: "icon", children: /* @__PURE__ */ jsx6("i", { className: "far fa-calendar-plus" }) })
      }
    ) }),
    right
  ] }) : /* @__PURE__ */ jsx6(
    BaseRangePicker,
    {
      ...props,
      value,
      onChange,
      onBlur,
      left,
      autoFix,
      right: /* @__PURE__ */ jsxs4(Fragment2, { children: [
        /* @__PURE__ */ jsx6("div", { className: "control", children: /* @__PURE__ */ jsx6(
          Button,
          {
            style: {
              backgroundColor: "#F2F3F4"
            },
            isSmall: props.isSmall,
            disabled: props.disabled,
            onClick: (e2) => {
              setExpanding(false);
              onChange?.(
                { start: value?.start, end: value?.start },
                e2
              );
              onBlur?.(value ?? {}, e2);
            },
            tips: {
              label: `${INPUT_ATTRIBUTES[props.inputType]["aria-label"]}\u3092\u5165\u529B\u3059\u308B`
            },
            children: /* @__PURE__ */ jsx6("span", { className: "icon", children: /* @__PURE__ */ jsx6("i", { className: "far fa-calendar-minus" }) })
          }
        ) }),
        right
      ] })
    }
  ) });
};

// lib/components/date-picker/base/base-picker.tsx
import { jsx as jsx7 } from "@emotion/react/jsx-runtime";
var BasePicker = (props) => {
  switch (props.type) {
    case "single":
      return /* @__PURE__ */ jsx7(BaseSinglePicker, { ...props });
    case "range":
      return /* @__PURE__ */ jsx7(BaseRangePicker, { ...props });
    case "expandable-range":
      return /* @__PURE__ */ jsx7(BaseExpandableRangePicker, { ...props });
    default:
      return null;
  }
};

// lib/components/date-picker/date-picker.tsx
import { jsx as jsx8 } from "@emotion/react/jsx-runtime";
var DatePicker = (props) => {
  return /* @__PURE__ */ jsx8(
    BasePicker,
    {
      ...props,
      inputType: "date",
      convert: (d2) => DateUtils.formatToDate(d2),
      parse: (d2) => DateUtils.fromDateFormat(d2)
    }
  );
};

// lib/components/date-picker/date-time-picker.tsx
import { forwardRef as forwardRef3 } from "react";
import { jsx as jsx9 } from "@emotion/react/jsx-runtime";
var DateTimePicker = forwardRef3((props, ref) => {
  return /* @__PURE__ */ jsx9(
    BasePicker,
    {
      ...props,
      innerRef: ref,
      inputType: "datetime-local",
      convert: (d2) => DateUtils.formatTzDate(d2, "yyyy-MM-dd'T'HH:mm"),
      parse: (d2) => DateUtils.fromTzFormat(d2, "yyyy-MM-dd'T'HH:mm")
    }
  );
});
DateTimePicker.displayName = "DateTimePicker";

// lib/components/date-picker/local-date-picker.tsx
import { forwardRef as forwardRef4 } from "react";
import { jsx as jsx10 } from "@emotion/react/jsx-runtime";
var LocalDatePicker = forwardRef4((props, ref) => {
  return /* @__PURE__ */ jsx10(
    BasePicker,
    {
      ...props,
      inputType: "date",
      innerRef: ref,
      convert: (d2) => localDateToInput(d2),
      parse: (d2) => LocalDate.parseSoft(d2)
    }
  );
});
LocalDatePicker.displayName = "LocalDatePicker";
var localDateToInput = (d2) => {
  return `${padZero(d2.year, 4)}-${padZero(d2.month, 2)}-${padZero(d2.day, 2)}`;
};
var padZero = (v2, length) => {
  return String(v2).padStart(length, "0");
};

// lib/components/date-picker/local-date-time-picker.tsx
import { forwardRef as forwardRef5 } from "react";
import { jsx as jsx11 } from "@emotion/react/jsx-runtime";
var LocalDateTimePicker = forwardRef5((props, ref) => {
  return /* @__PURE__ */ jsx11(
    BasePicker,
    {
      ...props,
      inputType: "datetime-local",
      innerRef: ref,
      convert: (d2) => localDateTimeToInput(d2),
      parse: (d2) => LocalDateTime.parseSoft(d2)
    }
  );
});
LocalDateTimePicker.displayName = "LocalDateTimePicker";
var localDateTimeToInput = (d2) => {
  return `${padZero2(d2.year, 4)}-${padZero2(d2.month, 2)}-${padZero2(
    d2.day,
    2
  )} ${padZero2(d2.hour, 2)}:${padZero2(d2.minute, 2)}`;
};
var padZero2 = (v2, length) => {
  return String(v2).padStart(length, "0");
};

// lib/components/date-picker/local-time-picker.tsx
import { forwardRef as forwardRef6 } from "react";
import { jsx as jsx12 } from "@emotion/react/jsx-runtime";
var LocalTimePicker = forwardRef6((props, ref) => {
  return /* @__PURE__ */ jsx12(
    BasePicker,
    {
      ...props,
      inputType: "time",
      innerRef: ref,
      convert: (d2) => localTimeToInput(d2),
      parse: (d2) => LocalTime.parseSoft(d2)
    }
  );
});
LocalTimePicker.displayName = "LocalTimePicker";
var localTimeToInput = (d2) => {
  return `${padZero3(d2.hour, 2)}:${padZero3(d2.minute, 2)}`;
};
var padZero3 = (v2, length) => {
  return String(v2).padStart(length, "0");
};

// lib/components/date-picker/relative-local-date-time-picker.tsx
import classNames3 from "classnames";
import { useMemo as useMemo2 } from "react";
import { Fragment as Fragment3, jsx as jsx13, jsxs as jsxs5 } from "@emotion/react/jsx-runtime";
var RelativeLocalDateTimePicker = ({
  baseDate,
  value,
  onChange,
  onBlur,
  enableDatePicker = false
  // デフォルトは無効
}) => {
  return /* @__PURE__ */ jsxs5("div", { className: "field has-addons", children: [
    /* @__PURE__ */ jsx13(
      TimeWithPrefixForm,
      {
        baseDate,
        value: value?.startAt,
        onChange: (v2) => onChange?.({
          startAt: v2,
          endAt: value?.endAt
        }),
        onBlur: () => {
          onChange?.(adjustTo24h(value?.startAt, value?.endAt));
          onBlur?.();
        },
        enableDatePicker
      }
    ),
    /* @__PURE__ */ jsx13("div", { className: "control", children: /* @__PURE__ */ jsx13("span", { className: classNames3("button is-static px-1"), children: "~" }) }),
    /* @__PURE__ */ jsx13(
      TimeWithPrefixForm,
      {
        baseDate,
        value: value?.endAt,
        onChange: (v2) => onChange?.({
          startAt: value?.startAt,
          endAt: v2
        }),
        onBlur: () => {
          onChange?.(adjustTo24h(value?.startAt, value?.endAt));
          onBlur?.();
        },
        enableDatePicker
      }
    )
  ] });
};
var SimpleDateDropdownPicker = ({
  baseDate,
  value,
  onChange
}) => {
  const dateOptions = useMemo2(() => {
    const base = LocalDate.schema.parse(baseDate);
    return [
      {
        label: "\u524D\u65E5",
        value: LocalDate.addDays(base, -1)
      },
      {
        label: "\u5F53\u65E5",
        value: base
      },
      {
        label: "\u7FCC\u65E5",
        value: LocalDate.addDays(base, 1)
      }
    ];
  }, [baseDate]);
  const currentLabel = useMemo2(() => {
    if (!value) return "\u5F53\u65E5";
    const selectedDate = LocalDate.schema.parse(value);
    const base = LocalDate.schema.parse(baseDate);
    const diff = LocalDate.countDays(base, selectedDate);
    return diff === -1 ? "\u524D\u65E5" : diff === 1 ? "\u7FCC\u65E5" : "\u5F53\u65E5";
  }, [baseDate, value]);
  return /* @__PURE__ */ jsx13("div", { className: "select", children: /* @__PURE__ */ jsx13(
    "select",
    {
      value: currentLabel,
      onChange: (e2) => {
        const selected = dateOptions.find(
          (opt) => opt.label === e2.target.value
        );
        if (selected) {
          onChange?.(selected.value);
        }
      },
      children: dateOptions.map((option) => /* @__PURE__ */ jsx13("option", { value: option.label, children: option.label }, option.label))
    }
  ) });
};
var TimeWithPrefixForm = ({
  baseDate,
  value,
  onChange,
  onBlur,
  enableDatePicker = false
}) => {
  const prefix = getPrefix(baseDate, value);
  const handleDateChange = (newDate) => {
    if (!value) return;
    onChange?.({
      ...newDate,
      hour: value.hour,
      minute: value.minute,
      second: value.second ?? 0,
      millisecond: value.millisecond ?? 0
    });
  };
  return /* @__PURE__ */ jsxs5(Fragment3, { children: [
    enableDatePicker ? (
      // 日付選択プルダウン
      /* @__PURE__ */ jsx13("div", { className: "control", children: /* @__PURE__ */ jsx13(
        SimpleDateDropdownPicker,
        {
          baseDate,
          value,
          onChange: handleDateChange
        }
      ) })
    ) : (
      // 従来のプレフィックス表示
      prefix && /* @__PURE__ */ jsx13("div", { className: "control", children: /* @__PURE__ */ jsx13("span", { className: classNames3("button is-static px-2"), children: prefix }) })
    ),
    /* @__PURE__ */ jsx13("div", { className: "control", children: /* @__PURE__ */ jsx13(
      LocalTimePicker,
      {
        type: "single",
        value,
        onChange: (v2) => onChange?.(
          v2 && {
            ...baseDate,
            ...value,
            ...v2
          }
        ),
        onBlur
      }
    ) })
  ] });
};
var getPrefix = (baseDate, date) => {
  const validBaseDate = LocalDate.schema.safeParse(baseDate).data;
  const validDate = LocalDate.schema.safeParse(date).data;
  const countFromBaseDate = validBaseDate && validDate && LocalDate.countDays(validBaseDate, validDate);
  return isNullable(countFromBaseDate) ? void 0 : countFromBaseDate === 0 ? void 0 : countFromBaseDate === 1 ? "\u7FCC\u65E5" : countFromBaseDate === -1 ? "\u524D\u65E5" : countFromBaseDate > 1 ? `${countFromBaseDate}\u65E5\u5F8C` : `${Math.abs(countFromBaseDate)}\u65E5\u524D`;
};
var adjustTo24h = (startAt, endAt) => {
  if (isNullable(startAt) || isNullable(endAt)) {
    return { startAt, endAt };
  }
  const startOn = LocalDate.schema.safeParse(startAt).data;
  const endTime = LocalTime.schema.safeParse(endAt).data;
  if (isNullable(startOn) || isNullable(endTime)) {
    return { startAt, endAt };
  }
  const isTimeReversed = localTimeToInput2(startAt) > localTimeToInput2(endAt);
  const fixedEndOn = isTimeReversed ? LocalDate.addDays(startOn, 1) : startOn;
  return {
    startAt,
    endAt: LocalDate.atTime(fixedEndOn, endTime)
  };
};
var localTimeToInput2 = (d2) => {
  return `${padZero4(d2.hour, 2)}:${padZero4(d2.minute, 2)}`;
};
var padZero4 = (v2, length) => {
  return String(v2).padStart(length, "0");
};

// lib/components/date-picker/year-month-date-picker.tsx
import { jsx as jsx14 } from "@emotion/react/jsx-runtime";
var YearMonthDatePicker = (props) => {
  return /* @__PURE__ */ jsx14(
    BasePicker,
    {
      ...props,
      inputType: "month",
      convert: (d2) => DateUtils.format(d2, "yyyy-MM"),
      parse: (d2) => DateUtils.fromFormat(d2, "yyyy-MM")
    }
  );
};

// lib/components/date-picker/year-month-picker.tsx
import { jsx as jsx15 } from "@emotion/react/jsx-runtime";
var YearMonthPicker = (props) => {
  return /* @__PURE__ */ jsx15(
    BasePicker,
    {
      ...props,
      inputType: "month",
      convert: (d2) => YearMonthToInput(d2),
      parse: (d2) => YearMonth.parseSoft(d2)
    }
  );
};
var YearMonthToInput = (d2) => {
  return `${padZero5(d2.year, 4)}-${padZero5(d2.month, 2)}`;
};
var padZero5 = (v2, length) => {
  return String(v2).padStart(length, "0");
};

// lib/components/denied-by-policy-icon/denied-by-policy-icon/denied-by-policy-icon.tsx
import { Fragment as Fragment4, jsx as jsx16, jsxs as jsxs6 } from "@emotion/react/jsx-runtime";
var DeniedByPolicyIcon = ({
  denied,
  deniedMessage
}) => {
  return /* @__PURE__ */ jsx16(Fragment4, { children: denied && /* @__PURE__ */ jsx16(
    Icon,
    {
      className: "ml-1",
      iconName: "fas fa-circle-question",
      style: { fontSize: "1rem" },
      tips: {
        placement: "right-end",
        label: /* @__PURE__ */ jsx16("p", { children: deniedMessage ?? /* @__PURE__ */ jsxs6(Fragment4, { children: [
          "\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
          /* @__PURE__ */ jsx16("br", {}),
          "\u64CD\u4F5C\u304C\u5FC5\u8981\u306A\u5834\u5408\u306F\u7BA1\u7406\u8005\u6A29\u9650\u3092\u6301\u3064\u30E6\u30FC\u30B6\u30FC\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002"
        ] }) })
      }
    }
  ) });
};

// lib/components/dropdown/base-dropdown/base-dropdown.tsx
import { useState as useState4 } from "react";
import classNames4 from "classnames";
import { usePopper } from "react-popper";

// ../../../node_modules/react-toastify/dist/react-toastify.esm.mjs
import e, { isValidElement as t, useRef as n, useLayoutEffect as o, useEffect as s, cloneElement as a, useSyncExternalStore as r, useState as i } from "react";
var c = (e2) => "number" == typeof e2 && !isNaN(e2);
var d = (e2) => "string" == typeof e2;
var u = (e2) => "function" == typeof e2;
var m = (e2) => t(e2) || d(e2) || u(e2) || c(e2);
function f(e2, t2, n2) {
  void 0 === n2 && (n2 = 300);
  const { scrollHeight: o2, style: s2 } = e2;
  requestAnimationFrame(() => {
    s2.minHeight = "initial", s2.height = o2 + "px", s2.transition = `all ${n2}ms`, requestAnimationFrame(() => {
      s2.height = "0", s2.padding = "0", s2.margin = "0", setTimeout(t2, n2);
    });
  });
}
function g(t2) {
  let { enter: a2, exit: r2, appendPosition: i2 = false, collapse: l = true, collapseDuration: c2 = 300 } = t2;
  return function(t3) {
    let { children: d2, position: u2, preventExitTransition: p, done: m2, nodeRef: g2, isIn: y, playToast: v2 } = t3;
    const h2 = i2 ? `${a2}--${u2}` : a2, T2 = i2 ? `${r2}--${u2}` : r2, E = n(0);
    return o(() => {
      const e2 = g2.current, t4 = h2.split(" "), n2 = (o2) => {
        o2.target === g2.current && (v2(), e2.removeEventListener("animationend", n2), e2.removeEventListener("animationcancel", n2), 0 === E.current && "animationcancel" !== o2.type && e2.classList.remove(...t4));
      };
      e2.classList.add(...t4), e2.addEventListener("animationend", n2), e2.addEventListener("animationcancel", n2);
    }, []), s(() => {
      const e2 = g2.current, t4 = () => {
        e2.removeEventListener("animationend", t4), l ? f(e2, m2, c2) : m2();
      };
      y || (p ? t4() : (E.current = 1, e2.className += ` ${T2}`, e2.addEventListener("animationend", t4)));
    }, [y]), e.createElement(e.Fragment, null, d2);
  };
}
var v = /* @__PURE__ */ new Map();
var h = [];
var T = /* @__PURE__ */ new Set();
var b = () => v.size > 0;
function I(e2, t2) {
  var n2;
  if (t2) return !(null == (n2 = v.get(t2)) || !n2.isToastActive(e2));
  let o2 = false;
  return v.forEach((t3) => {
    t3.isToastActive(e2) && (o2 = true);
  }), o2;
}
function _(e2, t2) {
  m(e2) && (b() || h.push({ content: e2, options: t2 }), v.forEach((n2) => {
    n2.buildToast(e2, t2);
  }));
}
function C(e2, t2) {
  v.forEach((n2) => {
    null != t2 && null != t2 && t2.containerId ? (null == t2 ? void 0 : t2.containerId) === n2.id && n2.toggle(e2, null == t2 ? void 0 : t2.id) : n2.toggle(e2, null == t2 ? void 0 : t2.id);
  });
}
var w = 1;
var k = () => "" + w++;
function P(e2) {
  return e2 && (d(e2.toastId) || c(e2.toastId)) ? e2.toastId : k();
}
function M(e2, t2) {
  return _(e2, t2), t2.toastId;
}
function x(e2, t2) {
  return { ...t2, type: t2 && t2.type || e2, toastId: P(t2) };
}
function A(e2) {
  return (t2, n2) => M(t2, x(e2, n2));
}
function B(e2, t2) {
  return M(e2, x("default", t2));
}
B.loading = (e2, t2) => M(e2, x("default", { isLoading: true, autoClose: false, closeOnClick: false, closeButton: false, draggable: false, ...t2 })), B.promise = function(e2, t2, n2) {
  let o2, { pending: s2, error: a2, success: r2 } = t2;
  s2 && (o2 = d(s2) ? B.loading(s2, n2) : B.loading(s2.render, { ...n2, ...s2 }));
  const i2 = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, l = (e3, t3, s3) => {
    if (null == t3) return void B.dismiss(o2);
    const a3 = { type: e3, ...i2, ...n2, data: s3 }, r3 = d(t3) ? { render: t3 } : t3;
    return o2 ? B.update(o2, { ...a3, ...r3 }) : B(r3.render, { ...a3, ...r3 }), s3;
  }, c2 = u(e2) ? e2() : e2;
  return c2.then((e3) => l("success", r2, e3)).catch((e3) => l("error", a2, e3)), c2;
}, B.success = A("success"), B.info = A("info"), B.error = A("error"), B.warning = A("warning"), B.warn = B.warning, B.dark = (e2, t2) => M(e2, x("default", { theme: "dark", ...t2 })), B.dismiss = function(e2) {
  !function(e3) {
    var t2;
    if (b()) {
      if (null == e3 || d(t2 = e3) || c(t2)) v.forEach((t3) => {
        t3.removeToast(e3);
      });
      else if (e3 && ("containerId" in e3 || "id" in e3)) {
        const t3 = v.get(e3.containerId);
        t3 ? t3.removeToast(e3.id) : v.forEach((t4) => {
          t4.removeToast(e3.id);
        });
      }
    } else h = h.filter((t3) => null != e3 && t3.options.toastId !== e3);
  }(e2);
}, B.clearWaitingQueue = function(e2) {
  void 0 === e2 && (e2 = {}), v.forEach((t2) => {
    !t2.props.limit || e2.containerId && t2.id !== e2.containerId || t2.clearQueue();
  });
}, B.isActive = I, B.update = function(e2, t2) {
  void 0 === t2 && (t2 = {});
  const n2 = ((e3, t3) => {
    var n3;
    let { containerId: o2 } = t3;
    return null == (n3 = v.get(o2 || 1)) ? void 0 : n3.toasts.get(e3);
  })(e2, t2);
  if (n2) {
    const { props: o2, content: s2 } = n2, a2 = { delay: 100, ...o2, ...t2, toastId: t2.toastId || e2, updateId: k() };
    a2.toastId !== e2 && (a2.staleId = e2);
    const r2 = a2.render || s2;
    delete a2.render, M(r2, a2);
  }
}, B.done = (e2) => {
  B.update(e2, { progress: 1 });
}, B.onChange = function(e2) {
  return T.add(e2), () => {
    T.delete(e2);
  };
}, B.play = (e2) => C(true, e2), B.pause = (e2) => C(false, e2);
var S = function(e2, t2) {
  return void 0 === t2 && (t2 = false), { enter: `Toastify--animate Toastify__${e2}-enter`, exit: `Toastify--animate Toastify__${e2}-exit`, appendPosition: t2 };
};
var H = g(S("bounce", true));
var F = g(S("slide", true));
var X = g(S("zoom"));
var Y = g(S("flip"));

// lib/components/dropdown/base-dropdown/base-dropdown.tsx
import { Fragment as Fragment5, jsx as jsx17, jsxs as jsxs7 } from "@emotion/react/jsx-runtime";
var BaseDropdown = ({
  isSmall,
  disabled,
  disabledMessage,
  tabIndex,
  className,
  tips,
  showOnHover,
  noBorder,
  style,
  isActive: controlledIsActive,
  setIsActive: controlledSetIsActive,
  overrideBackground,
  ...props
}) => {
  const { hovering, hoverSensor } = useHover();
  const popupHover = useHover();
  const [internalIsActive, setInternalIsActive] = useState4(false);
  const isActive = controlledIsActive ?? internalIsActive;
  const setIsActive = controlledSetIsActive ?? setInternalIsActive;
  const onClick = () => setIsActive(!isActive);
  const close = () => setIsActive(false);
  useKey("Escape", close);
  const isClickable = !disabled || !!disabledMessage;
  const [ref, setRef] = useState4(null);
  const [dropdownRef, setDropdownRef] = useState4(null);
  const { attributes, styles: styles3 } = usePopper(ref, dropdownRef, {
    placement: typeof props.placement !== "undefined" ? props.placement : "bottom-end"
  });
  const isShowing = isActive || showOnHover && !disabled && (popupHover.hovering || hovering);
  return /* @__PURE__ */ jsxs7("div", { className: classNames4("dropdown is-active"), children: [
    /* @__PURE__ */ jsxs7("div", { className: "dropdown-trigger", children: [
      /* @__PURE__ */ jsx17(
        "button",
        {
          type: "button",
          className: classNames4("button", className, {
            "is-small": isSmall
          }),
          style: {
            background: overrideBackground ? void 0 : "inherit",
            borderStyle: noBorder ? "none" : void 0,
            ...style
          },
          "aria-haspopup": "true",
          "aria-controls": "dropdown-menu",
          "aria-label": tips,
          disabled: !isClickable,
          onClick: (e2) => {
            e2.preventDefault();
            if (!disabled || !disabledMessage) {
              onClick();
            } else {
              B.info(disabledMessage);
            }
          },
          tabIndex,
          ref: setRef,
          ...hoverSensor,
          children: props.type === "icon" ? /* @__PURE__ */ jsx17("span", { className: "icon is-small", children: /* @__PURE__ */ jsx17("i", { className: classNames4("fas", props.iconType ?? "fa-bars") }) }) : /* @__PURE__ */ jsxs7(Fragment5, { children: [
            props.buttonIcon && /* @__PURE__ */ jsx17("span", { className: "icon is-small mr-2", children: /* @__PURE__ */ jsx17("i", { className: props.buttonIcon }) }),
            /* @__PURE__ */ jsx17("span", { children: props.title }),
            !props.hideCaret && /* @__PURE__ */ jsx17("span", { className: "icon is-small", children: /* @__PURE__ */ jsx17("i", { className: "fas fa-angle-down", "aria-hidden": "true" }) })
          ] })
        }
      ),
      !!tips && !isActive && /* @__PURE__ */ jsx17(
        Tooltips,
        {
          isActive: hovering,
          refElement: ref,
          label: tips,
          placement: showOnHover ? "top" : void 0
        }
      )
    ] }),
    isShowing && /* @__PURE__ */ jsx17(PopupPortal, { children: /* @__PURE__ */ jsx17(
      OutsideClickHandler,
      {
        onOutsideClick: close,
        excludeIds: [AscendPopupContainerId],
        children: /* @__PURE__ */ jsx17(
          "div",
          {
            className: "dropdown-menu has-text-left",
            role: "menu",
            ref: setDropdownRef,
            ...attributes.popper,
            ...popupHover.hoverSensor,
            style: {
              display: "block",
              zIndex: 50,
              paddingTop: "1em",
              marginTop: "-1em",
              ...styles3.popper
            },
            children: /* @__PURE__ */ jsx17("div", { className: "dropdown-content", children: props.children })
          }
        )
      }
    ) })
  ] });
};

// lib/components/dropdown/dropdown/dropdown.tsx
import React2, { useState as useState5 } from "react";
import { jsx as jsx18, jsxs as jsxs8 } from "@emotion/react/jsx-runtime";
var Dropdown = ({ menus, ...props }) => {
  const [isActive, setIsActive] = useState5(false);
  const [loading, setLoading] = useState5("idle");
  return /* @__PURE__ */ jsx18(
    BaseDropdown,
    {
      ...props,
      isActive: isActive || loading === "loading",
      setIsActive,
      children: menus.map((m2, index) => {
        if (isNullable(m2.title)) {
          return /* @__PURE__ */ jsx18("hr", { className: "dropdown-divider" }, index);
        }
        const Tag = isNonNullable(m2.onClick) ? "a" : "div";
        return /* @__PURE__ */ jsx18(React2.Fragment, { children: !m2.disable && loading !== "loading" ? /* @__PURE__ */ jsxs8(
          Tag,
          {
            className: "dropdown-item",
            style: {
              display: "block",
              padding: props.isSmall ? void 0 : "15px 10px"
            },
            onClick: async (e2) => {
              e2.stopPropagation();
              setLoading("loading");
              await m2.onClick?.();
              setLoading("idle");
              setIsActive(false);
            },
            children: [
              m2.icon && /* @__PURE__ */ jsx18("span", { className: "icon mr-2", children: /* @__PURE__ */ jsx18("i", { className: m2.icon }) }),
              m2.title
            ]
          }
        ) : /* @__PURE__ */ jsxs8(
          "div",
          {
            className: "dropdown-item",
            style: {
              color: "gray",
              display: "flex",
              alignItems: "center",
              opacity: 0.5,
              cursor: "not-allowed",
              padding: props.isSmall ? void 0 : "15px 10px"
            },
            children: [
              loading === "loading" && /* @__PURE__ */ jsx18("div", { children: /* @__PURE__ */ jsx18(
                "button",
                {
                  className: "button is-loading is-small mr-1",
                  style: {
                    border: "none"
                  },
                  disabled: true
                }
              ) }),
              /* @__PURE__ */ jsxs8("div", { children: [
                m2.icon && /* @__PURE__ */ jsx18("span", { className: "icon mr-2", children: /* @__PURE__ */ jsx18("i", { className: m2.icon }) }),
                m2.title
              ] })
            ]
          }
        ) }, index);
      })
    }
  );
};

// lib/components/dropdown/dropdown-elements/dropdown-elements.tsx
import classNames5 from "classnames";
import { Fragment as Fragment6, jsx as jsx19, jsxs as jsxs9 } from "@emotion/react/jsx-runtime";
var MinWidth = 320;
var DropdownTitleItem = (props) => /* @__PURE__ */ jsx19(
  "p",
  {
    ...props,
    className: classNames5("dropdown-item px-4 py-2", props.className),
    style: {
      fontWeight: 600,
      color: "#000000",
      minWidth: props.style?.minWidth ?? MinWidth,
      ...props.style
    }
  }
);
var DropdownSectionHeaderItem = (props) => /* @__PURE__ */ jsx19(
  "p",
  {
    ...props,
    className: classNames5("dropdown-item px-4 py-2", props.className),
    style: {
      fontWeight: 600,
      color: "#666E76",
      minWidth: props.style?.minWidth ?? MinWidth,
      ...props.style
    }
  }
);
var DropdownOptionItem = ({
  icon,
  children,
  ...props
}) => /* @__PURE__ */ jsx19(
  "a",
  {
    ...props,
    className: classNames5("dropdown-item px-4 py-2", props.className),
    style: {
      cursor: "pointer",
      minWidth: props.style?.minWidth ?? MinWidth,
      ...isNonNullable(icon) ? {
        display: "flex",
        alignItems: "center",
        gap: "0.25em"
      } : {},
      ...props.style
    },
    onClick: (e2) => {
      e2.preventDefault();
      props.onClick?.(e2);
    },
    children: isNonNullable(icon) ? /* @__PURE__ */ jsxs9(Fragment6, { children: [
      /* @__PURE__ */ jsx19("span", { style: { flex: "0 0 auto" }, children: /* @__PURE__ */ jsx19(Icon, { ...icon }) }),
      /* @__PURE__ */ jsx19("div", { style: { flex: "1 1" }, children })
    ] }) : children
  }
);
var DropdownBlockItem = (props) => /* @__PURE__ */ jsx19(
  "div",
  {
    ...props,
    className: classNames5("dropdown-item px-4 py-2", props.className),
    style: { minWidth: props.style?.minWidth ?? MinWidth, ...props.style }
  }
);
var DropdownDivider = () => /* @__PURE__ */ jsx19("hr", { className: "dropdown-divider m-0" });

// lib/components/form/common/form-field.tsx
import classNames6 from "classnames";
import { jsx as jsx20, jsxs as jsxs10 } from "@emotion/react/jsx-runtime";
var FormField = ({
  children,
  option,
  label,
  subLabel,
  noMarginBottom = false,
  required = false,
  error,
  warning,
  supplementary,
  className,
  tips,
  htmlFor,
  ...props
}) => {
  return /* @__PURE__ */ jsxs10(
    "div",
    {
      className: classNames6(
        "field",
        noMarginBottom ? "mb-0" : "mb-2",
        className
      ),
      ...props,
      children: [
        (label || subLabel || option) && /* @__PURE__ */ jsxs10(
          "div",
          {
            className: "mb-1",
            style: {
              display: "flex",
              gap: "1em",
              alignItems: "center"
            },
            children: [
              isNonNullable(label) && /* @__PURE__ */ jsxs10(
                "label",
                {
                  htmlFor,
                  className: "label mb-0",
                  style: { display: "flex", alignItems: "center", gap: "0.25em" },
                  children: [
                    label,
                    isNonNullable(tips) && /* @__PURE__ */ jsx20(Icon, { iconName: "fas fa-circle-question", tips }),
                    required && /* @__PURE__ */ jsx20(Required, {})
                  ]
                }
              ),
              isNonNullable(subLabel) && subLabel,
              isNonNullable(option) && /* @__PURE__ */ jsx20(
                "div",
                {
                  style: option.position === "left" ? void 0 : { marginLeft: "auto" },
                  children: option.component
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx20("div", { className: "control", children }),
        isNonNullable(supplementary) && /* @__PURE__ */ jsx20("div", { className: "help has-text-grey", children: isString(supplementary) ? supplementary : supplementary.map((w2) => /* @__PURE__ */ jsx20("p", { children: w2 }, w2)) }),
        isNonNullable(error) && /* @__PURE__ */ jsx20("div", { className: "help is-danger", children: errorToString(error)?.map((error2) => /* @__PURE__ */ jsx20("p", { children: error2 }, error2)) }),
        isNonNullable(warning) && /* @__PURE__ */ jsx20("div", { className: "help", style: { color: "#FC9C0D" }, children: Array.isArray(warning) ? warning.map((w2) => /* @__PURE__ */ jsx20("p", { children: w2 }, w2)) : warning })
      ]
    }
  );
};
var errorToString = (error) => {
  return isNullable(error) ? void 0 : isString(error) ? [error] : isStringArray(error) ? error : isString(error.message) ? [error.message] : isNonNullable(error.map) ? error.map((e2) => e2?.message ?? "") : void 0;
};

// lib/components/form/form-single-text-area-field/form-single-text-area-field.tsx
import classNames7 from "classnames";
import { jsx as jsx21 } from "@emotion/react/jsx-runtime";
var FormSingleTextAreaField = ({
  label,
  required,
  error,
  warning,
  registered,
  className,
  isTouched,
  style,
  ...inputProps
}) => {
  return /* @__PURE__ */ jsx21(
    FormField,
    {
      required,
      label,
      error,
      warning,
      style,
      children: /* @__PURE__ */ jsx21(
        "textarea",
        {
          ...inputProps,
          ...registered,
          className: classNames7(
            "input textarea",
            getFormClassName({ error, isTouched }),
            className
          )
        }
      )
    }
  );
};

// lib/components/form/form-single-text-field/form-single-text-field.tsx
import classNames8 from "classnames";
import { useId } from "react";
import { jsx as jsx22 } from "@emotion/react/jsx-runtime";
var FormSingleTextField = ({
  label,
  required,
  error,
  warning,
  registered,
  className,
  isTouched,
  style,
  ...inputProps
}) => {
  const id = useId();
  return /* @__PURE__ */ jsx22(
    FormField,
    {
      required,
      label,
      error,
      warning,
      style,
      htmlFor: id,
      children: /* @__PURE__ */ jsx22(
        "input",
        {
          type: "text",
          id,
          ...inputProps,
          ...registered,
          className: classNames8(
            "input",
            getFormClassName({ error, isTouched }),
            className
          )
        }
      )
    }
  );
};

// lib/components/form-chip/form-chip/form-chip.tsx
import { css as css3 } from "@emotion/react";
import { jsx as jsx23, jsxs as jsxs11 } from "@emotion/react/jsx-runtime";
var FormChip = ({ label, input }) => {
  return /* @__PURE__ */ jsxs11(
    "div",
    {
      css: css3`
        ${Typography.InputValue}
        display: flex;
        border: 1px solid
          ${input.isRequired && input.value === void 0 ? Colors.Accent100 : Colors.Gray20};
        border-radius: 4px;
      `,
      children: [
        /* @__PURE__ */ jsxs11(
          "label",
          {
            css: css3`
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          color: ${Colors.Gray80};
          background-color: ${Colors.Gray5};
          padding: 0.33em 0.66em;
          border-radius: 3px 0 0 3px;
          border-right: 1px solid
            ${input.isRequired && input.value === void 0 ? Colors.Accent100 : Colors.Gray20};
          min-width: 40px;
        `,
            children: [
              label,
              input.type === "term" && !input.fix && /* @__PURE__ */ jsxs11(
                "div",
                {
                  css: css3`
              ${Typography.InputValue}
              display: flex;
              margin: 0 0 0 0.66em;
              border-radius: 4px;
              border: 1px solid ${Colors.Gray20};
              overflow: hidden;
            `,
                  children: [
                    /* @__PURE__ */ jsx23(
                      "div",
                      {
                        css: css3`
                padding: 0 0.33em;
                color: ${input.level === "day" ? Colors.Main100 : Colors.Gray50};
                background-color: ${input.level === "day" ? Colors.Main10 : Colors.White};
                border-right: 1px solid ${Colors.Gray20};
                user-select: none;
                cursor: pointer;
              `,
                        onClick: () => {
                          const val = input.value;
                          if (input.mode === "point") {
                            input.onChange(input.mode, [
                              val[0] ? DateUtils.startOfDay(val[0]) : void 0,
                              val[0] ? DateUtils.endOfDay(val[0]) : void 0
                            ]);
                          } else {
                            input.onChange(input.mode, [
                              val[0] ? DateUtils.startOfDay(val[0]) : void 0,
                              val[1] ? DateUtils.endOfDay(val[1]) : void 0
                            ]);
                          }
                          input.onChangeLevelType("day");
                        },
                        children: "\u65E5"
                      }
                    ),
                    /* @__PURE__ */ jsx23(
                      "div",
                      {
                        css: css3`
                padding: 0 0.33em;
                color: ${input.level === "month" ? Colors.Main100 : Colors.Gray50};
                background-color: ${input.level === "month" ? Colors.Main10 : Colors.White};
                user-select: none;
                cursor: pointer;
              `,
                        onClick: () => {
                          const val = input.value;
                          if (input.mode === "point") {
                            input.onChange(input.mode, [
                              val[0] ? DateUtils.startOfMonth(val[0]) : void 0,
                              val[0] ? DateUtils.endOfMonth(val[0]) : void 0
                            ]);
                          } else {
                            input.onChange(input.mode, [
                              val[0] ? DateUtils.startOfMonth(val[0]) : void 0,
                              val[1] ? DateUtils.endOfMonth(val[1]) : void 0
                            ]);
                          }
                          input.onChangeLevelType("month");
                        },
                        children: "\u6708"
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx23(
          FormChipInputSelector,
          {
            ...input,
            css: css3`
          border-radius: 0 3px 3px 0;
        `
          }
        )
      ]
    }
  );
};

// lib/components/form-chip/form-chip-input-selector/components/multi-select-input/multi-select-input.tsx
import { Global, css as css6 } from "@emotion/react";
import { useEffect as useEffect3, useMemo as useMemo3 } from "react";
import { Controller, useFormContext as useFormContext2 } from "react-hook-form";
import Select from "react-select";

// lib/components/form-chip/form-chip-input-selector/components/common/select-option.tsx
import { css as css4 } from "@emotion/react";
import { jsx as jsx24, jsxs as jsxs12 } from "@emotion/react/jsx-runtime";
var NotSelectedValue = "$_undefined";
var NotSelectedOption = { value: NotSelectedValue, label: "\u6307\u5B9A\u306A\u3057" };
var SelectOption = (props) => {
  const { label, value } = props.data;
  return /* @__PURE__ */ jsxs12(
    "div",
    {
      css: css4`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.6em;
        background-color: ${props.isSelected ? Colors.Main05 : Colors.White};
        :hover {
          background-color: ${Colors.Main05};
        }
      `,
      onClick: () => {
        if (value === NotSelectedValue) {
          props.clearValue();
        } else {
          props.selectOption({ label, value });
        }
      },
      children: [
        label,
        props.isSelected && /* @__PURE__ */ jsx24(
          "i",
          {
            css: css4`
            color: ${Colors.Main100};
          `,
            className: "fa-solid fa-check"
          }
        )
      ]
    }
  );
};

// lib/components/form-chip/form-chip-input-selector/components/multi-select-input/multi-select-input-label.tsx
import { css as css5 } from "@emotion/react";
import { jsx as jsx25 } from "@emotion/react/jsx-runtime";
var MultiSelectInputLabel = ({
  data
}) => {
  const { label, color } = data;
  return /* @__PURE__ */ jsx25(
    "div",
    {
      css: css5`
        background-color: ${color ? color : Colors.Gray10};
        ${color && `color:${Colors.White};`};
        padding: 2px;
        line-height: 1;
      `,
      children: label
    }
  );
};

// lib/components/form-chip/form-chip-input-selector/components/multi-select-input/multi-select-input.tsx
import { Fragment as Fragment7, jsx as jsx26, jsxs as jsxs13 } from "@emotion/react/jsx-runtime";
var MultiSelectInput = ({
  className = "",
  name,
  options,
  value,
  placeholder = "\u9078\u629E\u3059\u308B",
  onChange
}) => {
  const { control, setValue } = useFormContext2();
  useEffect3(() => setValue(name, value), [name, setValue, value]);
  const ops = useMemo3(() => [NotSelectedOption, ...options], [options]);
  return /* @__PURE__ */ jsxs13(Fragment7, { children: [
    /* @__PURE__ */ jsx26(
      Controller,
      {
        name,
        control,
        render: ({ field }) => /* @__PURE__ */ jsx26(
          Select,
          {
            classNamePrefix: "rs",
            unstyled: true,
            menuPortalTarget: document.body,
            classNames: {
              control: () => className
            },
            css: css6`
              > .rs__control {
                ${Typography.InputValue}
                background-color: ${Colors.White};
                color: ${Colors.Gray};
                min-height: auto;
                min-width: 60px;
                border: none;
                display: flex;
                flex-wrap: nowrap;
                align-items: center;
                user-select: none;
                > .rs__value-container {
                  flex: 1 1 auto;
                  display: flex;
                  min-height: 26px;
                  gap: 0.33em;
                  padding: 0 0 0 4px;
                  > .rs__placeholder {
                    color: ${Colors.Gray30};
                  }
                  > .rs__multi-value {
                    flex: 0 0 auto;
                    display: flex;
                    padding: 0.33em 0;
                    > .rs__multi-value__label {
                    }
                    > .rs__multi-value__remove {
                      display: none;
                    }
                  }
                  > .rs__input-container {
                    margin: 0;
                    padding: 0;
                    overflow: hidden;
                    > .rs__input {
                    }
                  }
                }
                > .rs__indicators {
                  flex: 0 0 auto;
                  display: flex;
                  align-items: center;
                  color: ${Colors.Gray20};
                  > .rs__indicator-separator {
                    background-color: ${Colors.Gray20};
                    margin: 0.33em 0;
                  }
                  > .rs__dropdown-indicator {
                    display: flex;
                    align-items: center;
                    width: 16px;
                    height: 16px;
                  }
                }
              }
            `,
            isMulti: true,
            components: {
              Option: SelectOption,
              MultiValueLabel: MultiSelectInputLabel
            },
            options: ops,
            noOptionsMessage: () => "\u8A72\u5F53\u3059\u308B\u9805\u76EE\u304C\u3042\u308A\u307E\u305B\u3093",
            hideSelectedOptions: false,
            placeholder,
            closeMenuOnSelect: false,
            isClearable: false,
            menuPlacement: "auto",
            value: ops.filter((v2) => value?.includes(v2.value)),
            onChange: (next) => {
              field.onChange(next.map((v2) => v2.value));
              onChange([...next]);
            }
          }
        )
      }
    ),
    /* @__PURE__ */ jsx26(
      Global,
      {
        styles: css6`
          .rs__menu {
            ${Typography.SelectOption}
            position: absolute;
            min-width: 132px;
            width: auto;
            margin-top: 0.6em;
            padding: 0.6em 0;
            border-radius: 4px;
            background-color: ${Colors.White};
            z-index: 1;
            box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px,
              rgba(0, 0, 0, 0.1) 0px 4px 11px;
            user-select: none;
          }
        `
      }
    )
  ] });
};

// lib/components/form-chip/form-chip-input-selector/components/select-input/select-input.tsx
import { Global as Global2, css as css7 } from "@emotion/react";
import { useEffect as useEffect4, useMemo as useMemo4 } from "react";
import { Controller as Controller2, useFormContext as useFormContext3 } from "react-hook-form";
import Select2 from "react-select";
import { Fragment as Fragment8, jsx as jsx27, jsxs as jsxs14 } from "@emotion/react/jsx-runtime";
var SelectInput = ({
  className = "",
  isRequired,
  name,
  value,
  options,
  placeholder = "\u9078\u629E\u3059\u308B",
  onChange
}) => {
  const { control, setValue } = useFormContext3();
  useEffect4(() => setValue(name, value), [name, setValue, value]);
  const ops = useMemo4(
    () => [...isRequired ? [] : [NotSelectedOption], ...options],
    [isRequired, options]
  );
  const val = options.find((v2) => v2.value === value);
  return /* @__PURE__ */ jsxs14(Fragment8, { children: [
    /* @__PURE__ */ jsx27(
      Controller2,
      {
        name,
        control,
        render: ({ field }) => /* @__PURE__ */ jsx27(
          Select2,
          {
            classNamePrefix: "rs",
            unstyled: true,
            classNames: { control: () => className },
            menuPortalTarget: document.body,
            css: css7`
              > .rs__control {
                ${Typography.InputValue}
                background-color: ${Colors.White};
                color: ${Colors.Gray};
                min-height: auto;
                min-width: 60px;
                border: none;
                display: flex;
                align-items: center;
                user-select: none;
                > .rs__value-container {
                  flex: 1 1 auto;
                  display: flex;
                  min-height: 26px;
                  padding: 0 0.33em;
                  > .rs__placeholder {
                    color: ${Colors.Gray30};
                  }
                  > .rs__single-value {
                  }
                  > .rs__input-container {
                    width: 0;
                    height: 0;
                    > .rs__input {
                      width: 0;
                      height: 0;
                      opacity: 0;
                    }
                  }
                }
                > .rs__indicators {
                  flex: 0 0 auto;
                  color: ${Colors.Gray20};
                  > .rs__indicator-separator {
                    background-color: ${Colors.Gray20};
                    margin: 0.33em 0;
                  }
                  > .rs__dropdown-indicator {
                    display: flex;
                    align-items: center;
                    width: 16px;
                    height: 16px;
                  }
                }
              }
              > .rs__option {
                padding: 1em;
                width: 100%;
                :hover {
                  background-color: ${Colors.Main05};
                }
              }
            `,
            isMulti: false,
            components: { Option: SelectOption },
            noOptionsMessage: () => "\u8A72\u5F53\u3059\u308B\u9805\u76EE\u304C\u3042\u308A\u307E\u305B\u3093",
            options: ops,
            placeholder,
            value: val,
            onChange: (next) => {
              if (!next) {
                field.onChange(void 0);
                onChange(void 0);
                return;
              }
              field.onChange(next.value);
              onChange({ ...next });
            }
          },
          `_select_key__${val}`
        )
      }
    ),
    /* @__PURE__ */ jsx27(
      Global2,
      {
        styles: css7`
          .rs__menu {
            ${Typography.SelectOption}
            position: absolute;
            min-width: 132px;
            width: auto;
            margin-top: 0.6em;
            padding: 0.6em 0;
            border-radius: 4px;
            background-color: ${Colors.White};
            z-index: 1;
            box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px,
              rgba(0, 0, 0, 0.1) 0px 4px 11px;
            user-select: none;
          }
        `
      }
    )
  ] });
};

// lib/components/form-chip/form-chip-input-selector/components/term-input/term-input.tsx
import { css as css9 } from "@emotion/react";
import classnames from "classnames";
import { useEffect as useEffect5 } from "react";
import { Controller as Controller3, useFormContext as useFormContext4 } from "react-hook-form";

// lib/components/form-chip/form-chip-input-selector/components/term-input/term-input-item.tsx
import { css as css8 } from "@emotion/react";
import { jsx as jsx28, jsxs as jsxs15 } from "@emotion/react/jsx-runtime";
var TermInputItem = ({
  className,
  level,
  value,
  onChange
}) => {
  const strValue = !value ? void 0 : `${level === "month" ? DateUtils.formatToTzMonth(value) : DateUtils.formatToTzDate(value)}`;
  return /* @__PURE__ */ jsxs15(
    "div",
    {
      className,
      css: css8`
        ${Typography.InputValue}
        display: flex;
        align-items: center;
        background-color: ${Colors.White};
      `,
      children: [
        /* @__PURE__ */ jsx28(
          "span",
          {
            css: css8`
          cursor: pointer;
          color: ${Colors.Gray40};
          padding: 0 0.25em;
          display: flex;
          align-items: center;
        `,
            onClick: () => {
              if (!value) return;
              const next = level === "month" ? DateUtils.subMonths(value, 1) : DateUtils.subDays(value, 1);
              onChange(next);
            },
            children: /* @__PURE__ */ jsx28("i", { className: "fa-solid fa-angle-left" })
          }
        ),
        /* @__PURE__ */ jsx28(
          "input",
          {
            type: level === "month" ? "month" : "date",
            value: strValue,
            css: css8`
          ${Typography.InputValue}
          color: ${Colors.Gray};
          border: 0;
          padding: 0;
          margin: 0;
          outline: none;
          ::-webkit-calendar-picker-indicator {
            padding-left: 1em;
            background: transparent;
            color: transparent;
          }
        `,
            onChange: (e2) => {
              const d2 = DateUtils.fromFormat(
                e2.target.value,
                level === "month" ? "yyyy-MM" : "yyyy-MM-dd"
              );
              onChange(d2);
            }
          }
        ),
        /* @__PURE__ */ jsxs15(
          "div",
          {
            css: css8`
          right: 0;
          margin-left: -3.3em;
          color: ${Colors.Gray40};
          display: flex;
          align-items: center;
          pointer-events: none;
        `,
            children: [
              /* @__PURE__ */ jsx28(
                "i",
                {
                  className: "fa-solid fa-angle-right",
                  css: css8`
            height: 100%;
            cursor: pointer;
            color: ${Colors.Gray40};
            padding: 0 0.25em;
            display: flex;
            align-items: center;
            pointer-events: auto;
          `,
                  onClick: () => {
                    if (!value) return;
                    const next = level === "month" ? DateUtils.addMonths(value, 1) : DateUtils.addDays(value, 1);
                    onChange(next);
                  }
                }
              ),
              /* @__PURE__ */ jsx28(
                "span",
                {
                  css: css8`
            height: 100%;
            cursor: pointer;
            color: ${Colors.Gray};
            display: flex;
            align-items: center;
            pointer-events: none;
            padding: 0 0.25em 0 0;
          `,
                  children: /* @__PURE__ */ jsx28("i", { className: "fa-regular fa-calendar" })
                }
              )
            ]
          }
        )
      ]
    }
  );
};

// lib/components/form-chip/form-chip-input-selector/components/term-input/term-input.tsx
import { Fragment as Fragment9, jsx as jsx29, jsxs as jsxs16 } from "@emotion/react/jsx-runtime";
var TermInput = ({
  className,
  level,
  mode,
  name,
  value,
  onChange
}) => {
  const { control, setValue } = useFormContext4();
  useEffect5(
    () => setValue(name, { level, value }),
    [name, setValue, value, level]
  );
  const startOf = level === "day" ? DateUtils.startOfDay : DateUtils.startOfMonth;
  const endOf = level === "day" ? DateUtils.endOfDay : DateUtils.endOfMonth;
  return /* @__PURE__ */ jsx29(
    Controller3,
    {
      name,
      control,
      render: () => /* @__PURE__ */ jsxs16(
        "div",
        {
          className,
          css: css9`
            display: flex;
            background-color: ${Colors.White};
            user-select: none;
          `,
          children: [
            /* @__PURE__ */ jsx29(
              TermInputItem,
              {
                level,
                value: value[0],
                onChange: (next) => {
                  if (mode === "point") {
                    onChange(mode, [
                      next ? startOf(next) : void 0,
                      next ? endOf(next) : void 0
                    ]);
                  } else {
                    onChange(mode, [
                      next ? startOf(next) : void 0,
                      value[1] ? endOf(value[1]) : void 0
                    ]);
                  }
                }
              }
            ),
            mode === "range" && /* @__PURE__ */ jsxs16(Fragment9, { children: [
              /* @__PURE__ */ jsx29(
                "span",
                {
                  css: css9`
                  cursor: pointer;
                  background-color: ${Colors.Gray5};
                  color: ${Colors.Gray};
                  padding: 0 0.25em;
                  display: flex;
                  align-items: center;
                  border-left: solid 1px ${Colors.Gray20};
                  border-right: solid 1px ${Colors.Gray20};
                `,
                  children: "~"
                }
              ),
              /* @__PURE__ */ jsx29(
                TermInputItem,
                {
                  level,
                  value: value[1],
                  onChange: (next) => {
                    onChange(mode, [
                      value[0] ? startOf(value[0]) : void 0,
                      next ? endOf(next) : void 0
                    ]);
                  }
                }
              )
            ] }),
            /* @__PURE__ */ jsx29(
              "div",
              {
                css: css9`
              cursor: pointer;
              display: flex;
              align-items: center;
              padding: 0 0.25em;
              background-color: ${Colors.Gray5};
              color: ${Colors.Gray};
              border-left: solid 1px ${Colors.Gray20};
            `,
                onClick: () => {
                  if (value[0] === void 0) {
                    onChange(mode === "point" ? "range" : "point", [
                      void 0,
                      void 0
                    ]);
                    return;
                  }
                  onChange(mode === "point" ? "range" : "point", [
                    startOf(value[0]),
                    endOf(value[0])
                  ]);
                },
                children: /* @__PURE__ */ jsx29(
                  "i",
                  {
                    className: classnames(
                      "fa-regular",
                      mode === "range" ? "fa-calendar-minus" : "fa-calendar-plus"
                    )
                  }
                )
              }
            )
          ]
        }
      )
    }
  );
};

// lib/components/form-chip/form-chip-input-selector/form-chip-input-selector.tsx
import { Fragment as Fragment10, jsx as jsx30, jsxs as jsxs17 } from "@emotion/react/jsx-runtime";
var FormChipInputSelector = (props) => {
  return /* @__PURE__ */ jsxs17(Fragment10, { children: [
    props.type === "text" && /* @__PURE__ */ jsx30(TextInput, { ...props }),
    props.type === "select" && /* @__PURE__ */ jsx30(SelectInput, { ...props }),
    props.type === "multi-select" && /* @__PURE__ */ jsx30(MultiSelectInput, { ...props }),
    props.type === "term" && /* @__PURE__ */ jsx30(TermInput, { ...props })
  ] });
};

// lib/components/form-chip/form-chip-list/form-chip-list.tsx
import { css as css10 } from "@emotion/react";
import { jsx as jsx31 } from "@emotion/react/jsx-runtime";
var FormChipList = ({ className, inputs }) => {
  return /* @__PURE__ */ jsx31(
    "div",
    {
      className,
      css: css10`
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      `,
      children: inputs.map((v2) => /* @__PURE__ */ jsx31(FormChip, { label: v2.label, input: v2 }, v2.name))
    }
  );
};

// lib/components/frame/commons/frame-type-switch.tsx
import { Fragment as Fragment11, jsx as jsx32, jsxs as jsxs18 } from "@emotion/react/jsx-runtime";
var FrameTypeSwitch = ({ type, allowTypes, onFrameChange }) => {
  if (isNullable(allowTypes)) {
    return null;
  }
  return /* @__PURE__ */ jsx32(
    Dropdown,
    {
      type: "icon",
      isSmall: true,
      iconType: "fa-sliders",
      menus: ["drawer", "modal", "page"].filter((t2) => !allowTypes || allowTypes.includes(t2)).map((t2) => ({
        title: /* @__PURE__ */ jsxs18(Fragment11, { children: [
          matchType(t2, {
            drawer: "\u30C9\u30ED\u30EF\u30FC\u8868\u793A",
            modal: "\u30E2\u30FC\u30C0\u30EB\u8868\u793A",
            page: "\u30DA\u30FC\u30B8\u8868\u793A"
          }),
          type === t2 && /* @__PURE__ */ jsx32("span", { className: "icon is-small ml-2", children: /* @__PURE__ */ jsx32("i", { className: "fas fa-check" }) })
        ] }),
        onClick: () => onFrameChange(t2)
      })),
      tips: "\u8868\u793A\u65B9\u6CD5\u306E\u5909\u66F4",
      style: {
        backgroundColor: "#FFFFFF"
      }
    }
  );
};

// lib/components/list/titled-list/titled-list.tsx
import { css as css11 } from "@emotion/react";
import { jsx as jsx33, jsxs as jsxs19 } from "@emotion/react/jsx-runtime";
var TitledList = ({
  className,
  title,
  items,
  renderItem
}) => {
  return /* @__PURE__ */ jsxs19(
    "div",
    {
      className,
      css: css11`
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        background-color: ${Colors.White};
      `,
      children: [
        title && /* @__PURE__ */ jsx33(
          "div",
          {
            css: css11`
            flex: 0 0 auto;
            ${Typography.ListTitle}
            color: ${Colors.Gray50};
            padding: 4px 12px;
          `,
            children: title
          }
        ),
        /* @__PURE__ */ jsx33(
          "div",
          {
            css: css11`
          flex: 1 1 auto;
          user-select: none;
          overflow-y: scroll;
        `,
            children: items.map((v2, i2) => renderItem(v2, i2))
          }
        )
      ]
    }
  );
};

// lib/components/modal/base/base-modal.tsx
import { Fragment as Fragment12, jsx as jsx34, jsxs as jsxs20 } from "@emotion/react/jsx-runtime";
var BaseModal = ({
  isActive,
  isLarge,
  title,
  children,
  loading,
  submitText,
  disableSubmit,
  onSubmit,
  onClose
}) => {
  return /* @__PURE__ */ jsx34(
    ModalFrame,
    {
      isActive,
      isLarge,
      title,
      body: children,
      onClose,
      footer: /* @__PURE__ */ jsxs20(Fragment12, { children: [
        /* @__PURE__ */ jsx34("button", { className: "button is-failure is-fullwidth", onClick: onClose, children: onSubmit ? "\u30AD\u30E3\u30F3\u30BB\u30EB" : "\u9589\u3058\u308B" }),
        onSubmit && /* @__PURE__ */ jsx34(
          SubmitButton,
          {
            className: "is-info is-fullwidth",
            loading: loading ?? "idle",
            onClick: onSubmit,
            disabled: !!disableSubmit,
            children: submitText ?? "\u78BA\u5B9A"
          }
        )
      ] })
    }
  );
};

// lib/components/modal/dialog/confirm-dialog.tsx
import classNames9 from "classnames";
import { useEffect as useEffect6, useRef } from "react";
import { Fragment as Fragment13, jsx as jsx35, jsxs as jsxs21 } from "@emotion/react/jsx-runtime";
var ConfirmDialog = ({
  type = "info",
  title,
  description,
  isActive,
  disabled = false,
  confirmText,
  closeText = "\u30AD\u30E3\u30F3\u30BB\u30EB",
  loading = "idle",
  onConfirm,
  onClose
}) => {
  const buttonRef = useRef(null);
  useEffect6(() => {
    if (isActive && ["info", "success"].includes(type)) {
      buttonRef.current?.focus();
    }
  }, [isActive, buttonRef.current]);
  return /* @__PURE__ */ jsx35(
    BaseDialog,
    {
      title,
      description,
      isActive,
      footer: /* @__PURE__ */ jsxs21(Fragment13, { children: [
        /* @__PURE__ */ jsx35("button", { className: "button is-failure is-fullwidth", onClick: onClose, children: closeText }),
        /* @__PURE__ */ jsx35(
          SubmitButton,
          {
            ref: buttonRef,
            disabled,
            className: classNames9(
              "is-fullwidth",
              matchType(type, {
                info: "is-info",
                success: "is-success",
                warning: "is-warning",
                danger: "is-danger"
              })
            ),
            onClick: onConfirm,
            loading,
            children: confirmText
          }
        )
      ] }),
      onClose
    }
  );
};

// lib/components/modal/dialog/guide-dialog.tsx
import { jsx as jsx36 } from "@emotion/react/jsx-runtime";
var GuideDialog = ({ title, description, isActive, onNext }) => {
  return /* @__PURE__ */ jsx36(
    BaseDialog,
    {
      title,
      description,
      isActive,
      footer: /* @__PURE__ */ jsx36("button", { className: "button is-failure is-fullwidth", onClick: onNext, children: "OK" })
    }
  );
};

// lib/components/search-panel/check-list-item/check-list-item.tsx
import { css as css12 } from "@emotion/react";
import { useCallback } from "react";
import { jsx as jsx37, jsxs as jsxs22 } from "@emotion/react/jsx-runtime";
var CheckListItem = ({
  name,
  isChecked,
  label,
  subLabel,
  onChange
}) => {
  const handleClick = useCallback(
    () => onChange(name, !isChecked),
    [isChecked, onChange, name]
  );
  return /* @__PURE__ */ jsxs22(
    "div",
    {
      css: css12`
        ${Typography.CheckListLabel}
        color: ${Colors.Gray100};
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 4px;
        padding: 10px 8px;
        background-color: ${isChecked ? Colors.Main05 : Colors.White};
        cursor: pointer;
        :hover {
          background-color: ${Colors.Main05};
        }
      `,
      onClick: handleClick,
      children: [
        /* @__PURE__ */ jsx37(
          "div",
          {
            css: css12`
          width: 14px;
        `,
            children: isChecked && /* @__PURE__ */ jsx37(
              "i",
              {
                css: css12`
              color: ${Colors.Main100};
            `,
                className: "fa-solid fa-check"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs22(
          "div",
          {
            css: css12`
          ${Typography.CheckListLabel}
          color: ${Colors.Gray100};
          display: flex;
          align-items: center;
        `,
            children: [
              label,
              subLabel && /* @__PURE__ */ jsx37(
                "div",
                {
                  css: css12`
              ${Typography.CheckListSubLabel}
              color: ${Colors.Gray50};
              padding-left: 4px;
            `,
                  children: subLabel
                }
              )
            ]
          }
        )
      ]
    }
  );
};

// lib/components/search-panel/favorite-list-item/favorite-list-item.tsx
import { css as css13 } from "@emotion/react";
import { useMemo as useMemo5 } from "react";
import { jsx as jsx38, jsxs as jsxs23 } from "@emotion/react/jsx-runtime";
var FavoriteListItem = ({
  id,
  inputs,
  items,
  isEnabled,
  onSetCurrent,
  onSetDefault,
  onRemove
}) => {
  const title = useMemo5(
    () => /* @__PURE__ */ jsx38(
      "div",
      {
        css: css13`
          flex: 1 1 auto;
          ${Typography.FavListLabel}
        `,
        children: inputs.map((v2) => {
          const item = items.find((item2) => item2.name === v2.name);
          if (!item) return;
          return /* @__PURE__ */ jsxs23(
            "span",
            {
              css: css13`
                margin-right: 8px;
                :last-child {
                  margin-right: 0;
                }
              `,
              children: [
                /* @__PURE__ */ jsxs23(
                  "span",
                  {
                    css: css13`
                  color: ${Colors.Gray40};
                `,
                    children: [
                      item.label,
                      ":"
                    ]
                  }
                ),
                /* @__PURE__ */ jsx38(
                  "span",
                  {
                    css: css13`
                  color: ${Colors.Gray90};
                  word-break: break-all;
                `,
                    children: inputValueToString(v2, item)
                  }
                )
              ]
            },
            item.name
          );
        })
      }
    ),
    [inputs]
  );
  return /* @__PURE__ */ jsxs23(
    "div",
    {
      css: css13`
        display: flex;
        align-items: center;
        padding: 12px;
        cursor: pointer;
        background-color: ${Colors.White};
        :hover {
          background-color: ${Colors.Main05};
        }
      `,
      onClick: () => {
        onSetCurrent(id, isEnabled);
      },
      children: [
        title,
        /* @__PURE__ */ jsxs23(
          "div",
          {
            css: css13`
          flex: 0 0 auto;
          position: relative;
          width: 18px;
          height: 16px;
          margin-left: 8px;
          cursor: pointer;
        `,
            onClick: (e2) => {
              onSetDefault(id, isEnabled);
              e2.stopPropagation();
            },
            children: [
              isEnabled && /* @__PURE__ */ jsx38(
                "i",
                {
                  className: "fa-solid fa-star",
                  css: css13`
              position: absolute;
              color: ${Colors.Yellow100};
            `
                }
              ),
              /* @__PURE__ */ jsx38(
                "i",
                {
                  className: "fa-regular fa-star",
                  css: css13`
            position: absolute;
          `
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx38(
          Button,
          {
            css: css13`
          flex: 0 0 auto;
          width: 32px;
          height: 32px;
          margin-left: 8px;
        `,
            onClick: (e2) => {
              onRemove(id);
              e2.stopPropagation();
            },
            children: /* @__PURE__ */ jsx38(
              "i",
              {
                className: "fa-solid fa-trash",
                css: css13`
            ${Typography.IconSmall}
            color: ${Colors.Gray80};
          `
              }
            )
          }
        )
      ]
    }
  );
};

// lib/components/search-panel/search-condition-panel/search-condition-panel.tsx
import { css as css14 } from "@emotion/react";
import { useMemo as useMemo6 } from "react";
import { jsx as jsx39, jsxs as jsxs24 } from "@emotion/react/jsx-runtime";
var SearchConditionPanel = ({
  items,
  values,
  favoriteItems,
  disableFavorite = false,
  disableItemSelect = false,
  onChange,
  onFavoriteAdd,
  onFavoriteSetCurrent,
  onFavoriteSetDefault,
  onFavoriteRemove
}) => {
  const currents = useMemo6(() => {
    return values.reduce((acc, v2) => {
      acc[v2.name] = true;
      return acc;
    }, {});
  }, [values]);
  return /* @__PURE__ */ jsxs24(
    "div",
    {
      css: css14`
        display: flex;
        background-color: ${Colors.White};
        padding: 12px 0;
        height: 480px;
      `,
      children: [
        !disableItemSelect && /* @__PURE__ */ jsx39(
          TitledList,
          {
            css: css14`
            flex: 1 1 auto;
            width: 275px;
          `,
            title: "\u691C\u7D22\u9805\u76EE",
            items,
            renderItem: (v2) => /* @__PURE__ */ jsx39(
              CheckListItem,
              {
                ...v2,
                isChecked: currents[v2.name],
                onChange
              }
            )
          }
        ),
        !disableFavorite && /* @__PURE__ */ jsxs24(
          "div",
          {
            css: css14`
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            width: 275px;
            gap: 8px;
            border-left: solid 1px #e5e7e8;
          `,
            children: [
              /* @__PURE__ */ jsx39(
                Button,
                {
                  className: "button",
                  onClick: onFavoriteAdd,
                  css: css14`
              flex: 0 0 auto;
              ${Typography.Regular}
              color: ${Colors.Gray80};
              align-self: flex-start;
              margin-left: 12px;
              height: 26px;
            `,
                  children: "\u73FE\u5728\u306E\u691C\u7D22\u6761\u4EF6\u3092\u4FDD\u5B58"
                }
              ),
              /* @__PURE__ */ jsx39(
                TitledList,
                {
                  css: css14`
              flex: 1 1 auto;
            `,
                  title: "\u4FDD\u5B58\u3055\u308C\u305F\u691C\u7D22\u6761\u4EF6",
                  items: favoriteItems,
                  renderItem: (v2) => /* @__PURE__ */ jsx39(
                    FavoriteListItem,
                    {
                      ...v2,
                      items,
                      onRemove: onFavoriteRemove,
                      onSetCurrent: onFavoriteSetCurrent,
                      onSetDefault: onFavoriteSetDefault
                    }
                  )
                }
              )
            ]
          }
        )
      ]
    }
  );
};

// lib/components/search-panel/search-panel/search-panel.tsx
import { css as css15 } from "@emotion/react";
import classnames2 from "classnames";
import { useCallback as useCallback2, useEffect as useEffect7, useMemo as useMemo7, useRef as useRef2, useState as useState6 } from "react";
import { Fragment as Fragment14, jsx as jsx40, jsxs as jsxs25 } from "@emotion/react/jsx-runtime";
var SearchPanel = ({
  storageKey,
  items: searchConditionItems,
  values = [],
  defaultValues = [],
  disableFavorite = false,
  disableItemSelect = false,
  onChipsChanged,
  hideExpandButton = false
}) => {
  const { favorites, saveFavorite, removeFavorite, setCurrent, setDefault } = useSearchConditionFavorite(
    storageKey,
    searchConditionItems,
    onChipsChanged,
    disableFavorite
  );
  const [isOpen, setIsOpen] = useState6(false);
  const [isExpanded, setIsExpanded] = useState6(false);
  const refMain = useRef2(null);
  const height = useMemo7(() => {
    if (refMain.current && isExpanded) {
      return refMain.current.getBoundingClientRect().height + "px";
    }
    return "auto";
  }, [isExpanded]);
  const handleReset = useCallback2(() => {
    onChipsChanged(ActionType.Reset, defaultValues);
  }, []);
  const handleSave = () => saveFavorite(values);
  const handleSetCurrent = (id) => {
    const item = favorites.items.find((v2) => v2.id === id);
    if (item) {
      onChipsChanged(ActionType.FavoriteSet, item.inputs);
    }
  };
  const handleChangeChips = (name, next) => {
    const item = searchConditionItems.find((v2) => name === v2.name);
    if (!item) return;
    let items = [];
    if (next) {
      setCurrent();
      items = [...values, initCurrentSearchConditionItem(item)];
    } else {
      if (!item.isRequired) {
        items = values.filter((v2) => v2.name !== item.name);
      }
    }
    onChipsChanged(ActionType.UpdateItem, items);
  };
  useEffect7(() => {
    const listener = () => {
      setIsOpen(false);
    };
    addEventListener("click", listener);
    return () => removeEventListener("click", listener);
  });
  const currentInputs = useMemo7(() => {
    return values.map((v2, i2) => {
      const item = searchConditionItems.find((vv) => vv.name === v2.name);
      switch (v2.type) {
        case "text": {
          if (item?.type !== v2.type) break;
          return {
            ...item,
            ...v2,
            onChange: (next) => {
              const temp = [...values];
              temp[i2] = { ...v2, value: next };
              onChipsChanged(ActionType.UpdateValue, temp);
            }
          };
        }
        case "select": {
          if (item?.type !== v2.type) break;
          return {
            ...item,
            ...v2,
            onChange: (next) => {
              const temp = [...values];
              temp[i2] = { ...v2, value: next?.value };
              onChipsChanged(ActionType.UpdateValue, temp);
            }
          };
        }
        case "multi-select": {
          if (item?.type !== v2.type) break;
          return {
            ...item,
            ...v2,
            onChange: (next) => {
              const temp = [...values];
              temp[i2] = {
                ...v2,
                value: next.flatMap(
                  (v3) => v3.value === void 0 ? [] : v3.value
                )
              };
              onChipsChanged(ActionType.UpdateValue, temp);
            }
          };
        }
        case "term": {
          if (item?.type !== v2.type) break;
          return {
            ...item,
            ...v2,
            onChangeLevelType: (next) => {
              const temp = [...values];
              temp[i2] = { ...v2, level: next };
              onChipsChanged(ActionType.UpdateValue, temp);
            },
            onChange: (nextMode, next) => {
              const temp = [...values];
              temp[i2] = { ...v2, mode: nextMode, value: next };
              onChipsChanged(ActionType.UpdateValue, temp);
            }
          };
        }
      }
      return void 0;
    }).filter((v2) => v2 !== void 0);
  }, [values, onChipsChanged]);
  return /* @__PURE__ */ jsx40(Form, { children: /* @__PURE__ */ jsxs25(
    "div",
    {
      css: css15`
          background-color: #fff;
          position: relative;
          width: 100%;
        `,
      children: [
        isExpanded && /* @__PURE__ */ jsx40(
          "div",
          {
            css: css15`
              height: ${height};
            `
          }
        ),
        /* @__PURE__ */ jsxs25(
          "div",
          {
            ref: refMain,
            css: css15`
            background-color: #fff;
            display: flex;
            top: 0;
            width: 100%;
            position: ${isExpanded ? "absolute" : "relative"};
            z-index: 1;
            padding: 12px 12px;
          `,
            children: [
              /* @__PURE__ */ jsxs25(
                "div",
                {
                  css: css15`
              flex: 1 1 auto;
              display: flex;
              flex-direction: column;
              gap: 8px;
            `,
                  children: [
                    /* @__PURE__ */ jsx40(
                      FormChipList,
                      {
                        inputs: currentInputs,
                        css: css15`
                max-height: ${isExpanded ? "auto" : "84px"};
                overflow: hidden;
              `
                      }
                    ),
                    !disableFavorite && /* @__PURE__ */ jsx40(
                      "span",
                      {
                        css: css15`
                  ${Typography.Regular};
                  flex: 0 0 auto;
                  align-self: flex-start;
                  color: ${Colors.Main};
                  user-select: none;
                  cursor: pointer;
                  white-space: nowrap;
                `,
                        onClick: handleSave,
                        children: "\u73FE\u5728\u306E\u691C\u7D22\u6761\u4EF6\u3092\u4FDD\u5B58"
                      }
                    )
                  ]
                }
              ),
              !hideExpandButton && /* @__PURE__ */ jsx40(
                Button,
                {
                  className: "button",
                  onClick: () => {
                    setIsExpanded(!isExpanded);
                  },
                  css: css15`
                flex: 0 0 auto;
                align-self: flex-end;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 24px;
                height: 24px;
                padding: 0;
                margin-left: 12px;
              `,
                  children: /* @__PURE__ */ jsx40(
                    "i",
                    {
                      className: classnames2(
                        "fa-solid ",
                        isExpanded ? "fa-chevron-up" : "fa-chevron-down"
                      ),
                      css: css15`
                  color: ${Colors.Main100};
                `
                    }
                  )
                }
              ),
              !(disableFavorite && disableItemSelect) && /* @__PURE__ */ jsxs25(
                "div",
                {
                  css: css15`
                display: flex;
                flex-direction: column;
                align-self: flex-start;
                gap: 8px;
                margin-left: 12px;
                position: relative;
              `,
                  children: [
                    /* @__PURE__ */ jsxs25(
                      Button,
                      {
                        className: "button",
                        onClick: (e2) => {
                          setIsOpen(!isOpen);
                          e2.stopPropagation();
                        },
                        css: css15`
                  display: flex;
                  gap: 8px;
                  position: relative;
                  width: 140px;
                  height: 40px;
                `,
                        children: [
                          /* @__PURE__ */ jsx40(
                            "i",
                            {
                              className: "fa-solid fa-sliders",
                              css: css15`
                    color: ${Colors.Main100};
                  `
                            }
                          ),
                          "\u691C\u7D22\u9805\u76EE"
                        ]
                      }
                    ),
                    /* @__PURE__ */ jsx40(
                      "span",
                      {
                        css: css15`
                  color: ${Colors.Main};
                  ${Typography.Regular};
                  flex: 0 0 auto;
                  align-self: flex-start;
                  user-select: none;
                  cursor: pointer;
                  white-space: nowrap;
                `,
                        onClick: handleReset,
                        children: "\u5168\u9805\u76EE\u3092\u30AF\u30EA\u30A2"
                      }
                    ),
                    isOpen && /* @__PURE__ */ jsxs25(Fragment14, { children: [
                      /* @__PURE__ */ jsx40(
                        "div",
                        {
                          css: css15`
                      position: fixed;
                      width: 100%;
                      height: 100vh;
                      top: 0;
                      bottom: 0;
                      left: 0;
                      right: 0;
                    `
                        }
                      ),
                      /* @__PURE__ */ jsx40(
                        "div",
                        {
                          css: css15`
                      position: absolute;
                      text-align: left;
                      top: 100%;
                      right: 0;
                      margin-top: 8px;
                      border-radius: 4px;
                      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px,
                        rgba(0, 0, 0, 0.1) 0px 4px 11px;
                      z-index: 1;
                    `,
                          onClick: (e2) => e2.stopPropagation(),
                          children: /* @__PURE__ */ jsx40(
                            SearchConditionPanel,
                            {
                              items: searchConditionItems,
                              values,
                              favoriteItems: favorites.items.map((v2) => ({
                                ...v2,
                                isEnabled: favorites.currentId !== void 0 && v2.id === favorites.currentId
                              })),
                              disableFavorite,
                              disableItemSelect,
                              onChange: handleChangeChips,
                              onFavoriteAdd: handleSave,
                              onFavoriteSetCurrent: handleSetCurrent,
                              onFavoriteSetDefault: (id, isEnabled) => {
                                if (isEnabled) {
                                  setDefault(void 0);
                                } else {
                                  setDefault(id);
                                }
                              },
                              onFavoriteRemove: (id) => removeFavorite(id)
                            }
                          )
                        }
                      )
                    ] })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  ) });
};

// lib/components/select/base/base-creatable-select.tsx
import { components } from "react-select";

// lib/components/select/base/creatable-styled-select.tsx
import CreatableSelect from "react-select/creatable";
import { jsx as jsx41 } from "@emotion/react/jsx-runtime";
var CreatableStyledSelect = ({
  placeholder = "\u9078\u629E\u3059\u308B",
  noOptionsMessage = () => "\u9078\u629E\u5BFE\u8C61\u304C\u3042\u308A\u307E\u305B\u3093",
  isClearable = true,
  styles: propsStyles,
  minWidth,
  maxWidth,
  innerRef,
  onCreateOption,
  ...props
}) => {
  return /* @__PURE__ */ jsx41("div", { style: { display: "flex" }, children: /* @__PURE__ */ jsx41(
    CreatableSelect,
    {
      placeholder,
      formatCreateLabel: (v2) => `\u300C${v2}\u300D\u3092\u767B\u9332\u3057\u3066\u5229\u7528\u3059\u308B\u3002`,
      noOptionsMessage,
      isClearable,
      minMenuHeight: 400,
      maxMenuHeight: 400,
      menuPosition: "fixed",
      menuPortalTarget: document.getElementById(AscendPopupContainerId),
      styles: styles(propsStyles, props.className, minWidth, maxWidth),
      closeMenuOnSelect: !props.isMulti,
      ref: innerRef,
      onCreateOption,
      ...props
    }
  ) });
};
var styles = (styles3 = {}, className, minWidth, maxWidth) => {
  const status = getStatus(className);
  return {
    ...styles3,
    // 全体
    container: baseStyleOverwrite(styles3.container, {
      minWidth: minWidth ?? 120,
      maxWidth,
      width: isNullable(minWidth) ? "100%" : void 0
      // minWidthを設定していない場合はfullWidth
    }),
    // 入力部分
    control: baseStyleOverwrite(styles3.control, {
      borderColor: matchType(status, {
        success: "#48c78e",
        danger: "#f14668",
        normal: "#DBDBDB"
      })
    }),
    valueContainer: baseStyleOverwrite(styles3.valueContainer, {
      padding: "3px 4px 3px 8px"
    }),
    // Indicator
    indicatorSeparator: baseStyleOverwrite(styles3.indicatorSeparator, {
      backgroundColor: "#DBDBDB"
    }),
    dropdownIndicator: baseStyleOverwrite(styles3.dropdownIndicator, {
      padding: "8px 4px"
    }),
    clearIndicator: baseStyleOverwrite(styles3.clearIndicator, {
      padding: "8px 4px 8px 0px"
    }),
    // メニュー
    menuPortal: baseStyleOverwrite(styles3.menuPortal, {
      zIndex: 9999
    }),
    menu: baseStyleOverwrite(styles3.menu, {
      minWidth: "16em"
    }),
    groupHeading: baseStyleOverwrite(styles3.menu, {
      position: "sticky",
      top: "-4px",
      backgroundColor: "#ffffff"
    }),
    // valueの表示
    placeholder: baseStyleOverwrite(styles3.placeholder, {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }),
    singleValue: baseStyleOverwrite(styles3.singleValue, {
      textOverflow: void 0,
      display: "flex",
      alignItems: "center"
    }),
    multiValueLabel: baseStyleOverwrite(styles3.multiValueLabel, {
      textOverflow: void 0
    })
  };
};
var baseStyleOverwrite = (config, baseStyles) => (base, props) => {
  const override = {
    ...base,
    ...baseStyles
  };
  return config?.(override, props) ?? override;
};
var getStatus = (className) => {
  if (className?.includes("is-success") ?? false) {
    return "success";
  }
  if (className?.includes("is-danger") ?? false) {
    return "danger";
  }
  return "normal";
};

// lib/components/select/base/base-creatable-select.tsx
import { jsx as jsx42, jsxs as jsxs26 } from "@emotion/react/jsx-runtime";
var BaseCreatableSelect = ({
  filterOption,
  value,
  isSearchable = true,
  ...props
}) => {
  const dropdownHelpMessage = isSearchable ? isNonNullable(props.searchHints) ? `${props.searchHints.join("\u3001")}\u3067\u691C\u7D22\u3067\u304D\u307E\u3059\u3002` : "\u5165\u529B\u3067\u691C\u7D22\u3067\u304D\u307E\u3059\u3002" : void 0;
  return /* @__PURE__ */ jsx42(
    CreatableStyledSelect,
    {
      ...props,
      isSearchable,
      value: value ?? null,
      isOptionDisabled: (option) => option.disabled ?? false,
      formatOptionLabel: (option) => optionLabel(option),
      components: {
        Option: (props2) => /* @__PURE__ */ jsxs26(components.Option, { ...props2, children: [
          props2.children,
          props2.data.subLabel && /* @__PURE__ */ jsx42("div", { style: { fontSize: "0.75em", lineHeight: 1 }, children: props2.data.subLabel })
        ] }),
        MenuList: (props2) => /* @__PURE__ */ jsxs26(components.MenuList, { ...props2, children: [
          dropdownHelpMessage && /* @__PURE__ */ jsxs26(
            "div",
            {
              className: "mx-2 mb-1 py-1",
              style: { fontSize: "0.8em", borderBottom: `1px solid #999FA3` },
              children: [
                /* @__PURE__ */ jsx42(Icon, { iconName: "fas fa-circle-info" }),
                dropdownHelpMessage
              ]
            }
          ),
          props2.children
        ] }),
        ...props.components
      },
      filterOption: (option, rawInput) => {
        if (isNullable(option.value)) {
          return true;
        }
        if (option.data.unused ?? false) {
          return false;
        }
        const candidates = [
          ...option.data.candidates ?? [],
          option.data.label
        ];
        const isCandidateMatch = StringUtils.isMatchCandidates(
          rawInput ?? "",
          candidates
        );
        const isCustomFilterMatch = filterOption?.(option, rawInput) ?? true;
        return isCandidateMatch && isCustomFilterMatch;
      }
    }
  );
};
var optionLabel = ({
  label,
  unused = false
}) => {
  return /* @__PURE__ */ jsxs26(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "0.25em"
      },
      children: [
        /* @__PURE__ */ jsx42("span", { children: label }),
        unused && /* @__PURE__ */ jsx42("span", { style: groupBadgeStyles, children: "\u7121\u52B9" })
      ]
    }
  );
};
var groupBadgeStyles = {
  backgroundColor: "#ffdd57",
  borderRadius: "0.25em",
  color: "#000000b3",
  display: "inline-block",
  fontSize: 12,
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.25em 0.5em",
  textAlign: "center"
};

// lib/components/select/base/base-select.tsx
import { components as components2 } from "react-select";

// lib/components/select/base/styled-select.tsx
import Select3 from "react-select";
import { jsx as jsx43 } from "@emotion/react/jsx-runtime";
var StyledSelect = ({
  placeholder = "\u9078\u629E\u3059\u308B",
  noOptionsMessage = () => "\u9078\u629E\u5BFE\u8C61\u304C\u3042\u308A\u307E\u305B\u3093",
  isClearable = true,
  styles: propsStyles,
  isSmall,
  minWidth,
  maxWidth,
  innerRef,
  ...props
}) => {
  return /* @__PURE__ */ jsx43("div", { style: { display: "flex", flex: "1 1" }, children: /* @__PURE__ */ jsx43(
    Select3,
    {
      placeholder,
      noOptionsMessage,
      isClearable,
      minMenuHeight: 400,
      maxMenuHeight: 400,
      menuPosition: "fixed",
      menuPortalTarget: document.getElementById(AscendPopupContainerId),
      styles: styles2(
        propsStyles,
        props.className,
        isSmall,
        minWidth,
        maxWidth
      ),
      closeMenuOnSelect: !props.isMulti,
      ref: innerRef,
      ...props
    }
  ) });
};
var styles2 = (styles3 = {}, className, isSmall, minWidth, maxWidth) => {
  const status = getStatus2(className);
  return {
    ...styles3,
    // 全体
    container: baseStyleOverwrite2(styles3.container, {
      minWidth: minWidth ?? 120,
      maxWidth,
      width: isNullable(minWidth) ? "100%" : void 0
      // minWidthを設定していない場合はfullWidth
    }),
    // 入力部分
    control: baseStyleOverwrite2(styles3.control, {
      borderColor: matchType(status, {
        success: "#48c78e",
        danger: "#f14668",
        normal: "#DBDBDB"
      }),
      minHeight: isSmall ? "30px" : "40px"
    }),
    valueContainer: baseStyleOverwrite2(styles3.valueContainer, {
      padding: isSmall ? "1px 2px 1px 4px" : "3px 4px 3px 8px",
      fontSize: isSmall ? "0.75em" : "1em"
    }),
    // Indicator
    indicatorSeparator: baseStyleOverwrite2(styles3.indicatorSeparator, {
      backgroundColor: "#DBDBDB",
      marginTop: isSmall ? "4px" : "8px",
      marginBottom: isSmall ? "4px" : "8px"
    }),
    dropdownIndicator: baseStyleOverwrite2(styles3.dropdownIndicator, {
      padding: isSmall ? "4px 2px" : "8px 4px"
    }),
    clearIndicator: baseStyleOverwrite2(styles3.clearIndicator, {
      padding: isSmall ? "4px 2px 4px 0px" : "8px 4px 8px 0px"
    }),
    // メニュー
    menuPortal: baseStyleOverwrite2(styles3.menuPortal, {
      zIndex: 9999
    }),
    menu: baseStyleOverwrite2(styles3.menu, {
      minWidth: "16em"
    }),
    groupHeading: baseStyleOverwrite2(styles3.menu, {
      position: "sticky",
      top: "-4px",
      backgroundColor: "#ffffff"
    }),
    // valueの表示
    placeholder: baseStyleOverwrite2(styles3.placeholder, {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }),
    singleValue: baseStyleOverwrite2(styles3.singleValue, {
      textOverflow: void 0,
      display: "flex",
      alignItems: "center"
    }),
    multiValueLabel: baseStyleOverwrite2(styles3.multiValueLabel, {
      textOverflow: void 0
    })
  };
};
var baseStyleOverwrite2 = (config, baseStyles) => (base, props) => {
  const override = {
    ...base,
    ...baseStyles
  };
  return config?.(override, props) ?? override;
};
var getStatus2 = (className) => {
  if (className?.includes("is-success") ?? false) {
    return "success";
  }
  if (className?.includes("is-danger") ?? false) {
    return "danger";
  }
  return "normal";
};

// lib/components/select/base/base-select.tsx
import { jsx as jsx44, jsxs as jsxs27 } from "@emotion/react/jsx-runtime";
var BaseSelect = ({
  filterOption,
  value,
  isSearchable = true,
  ...props
}) => {
  const dropdownHelpMessage = isSearchable ? isNonNullable(props.searchHints) ? `${props.searchHints.join("\u3001")}\u3067\u691C\u7D22\u3067\u304D\u307E\u3059\u3002` : "\u5165\u529B\u3067\u691C\u7D22\u3067\u304D\u307E\u3059\u3002" : void 0;
  return /* @__PURE__ */ jsx44(
    StyledSelect,
    {
      ...props,
      isSearchable,
      value: value ?? null,
      isDisabled: props.isDisabled,
      isOptionDisabled: (option) => option.disabled ?? false,
      formatOptionLabel: (option) => optionLabel2(option),
      components: {
        Option: (props2) => /* @__PURE__ */ jsxs27(components2.Option, { ...props2, children: [
          props2.children,
          props2.data.subLabel && /* @__PURE__ */ jsx44("div", { style: { fontSize: "0.75em", lineHeight: 1 }, children: props2.data.subLabel })
        ] }),
        MenuList: (props2) => /* @__PURE__ */ jsxs27(components2.MenuList, { ...props2, children: [
          dropdownHelpMessage && /* @__PURE__ */ jsxs27(
            "div",
            {
              className: "mx-2 mb-1 py-1",
              style: { fontSize: "0.8em", borderBottom: `1px solid #999FA3` },
              children: [
                /* @__PURE__ */ jsx44(Icon, { iconName: "fas fa-circle-info" }),
                dropdownHelpMessage
              ]
            }
          ),
          props2.children
        ] }),
        ...props.components
      },
      filterOption: (option, rawInput) => {
        if (isNullable(option.value)) {
          return true;
        }
        if (option.data.unused ?? false) {
          return false;
        }
        const candidates = [
          ...option.data.candidates ?? [],
          option.data.label
        ];
        const isCandidateMatch = StringUtils.isMatchCandidates(
          rawInput ?? "",
          candidates
        );
        const isCustomFilterMatch = filterOption?.(option, rawInput) ?? true;
        return isCandidateMatch && isCustomFilterMatch;
      }
    }
  );
};
var optionLabel2 = ({
  label,
  unused = false
}) => {
  return /* @__PURE__ */ jsxs27(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "0.25em"
      },
      children: [
        /* @__PURE__ */ jsx44("span", { children: label }),
        unused && /* @__PURE__ */ jsx44("span", { style: groupBadgeStyles2, children: "\u7121\u52B9" })
      ]
    }
  );
};
var groupBadgeStyles2 = {
  backgroundColor: "#ffdd57",
  borderRadius: "0.25em",
  color: "#000000b3",
  display: "inline-block",
  fontSize: 12,
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.25em 0.5em",
  textAlign: "center"
};

// lib/components/select/creatable-multi-select/creatable-multi-select.tsx
import { jsx as jsx45 } from "@emotion/react/jsx-runtime";
var CreatableMultiSelect = ({
  values,
  ...props
}) => {
  return /* @__PURE__ */ jsx45(
    BaseCreatableSelect,
    {
      isMulti: true,
      ...props,
      value: flatOptions(props.options ?? []).filter(
        (o2) => values?.includes(o2.value)
      )
    }
  );
};
var flatOptions = (options) => {
  return options.flatMap((o2) => {
    switch (o2.type) {
      case "group":
        return o2.options;
      case "item":
        return [o2];
    }
  });
};

// lib/components/select/multi-select/multi-select.tsx
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors
} from "@dnd-kit/core";
import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React4 from "react";
import { components as components3 } from "react-select";
import { jsx as jsx46 } from "@emotion/react/jsx-runtime";
var MultiSelect = ({
  values,
  isSortable = false,
  ...props
}) => {
  const Wrapper = isSortable ? SortableWrapper : React4.Fragment;
  const flatedOptions = flatOptions2(props.options ?? []);
  const flatedOptionValues = flatedOptions.map((o2) => o2.value);
  const onChange = (values2) => props.onChange?.(
    values2.map((v2) => flatedOptions.find((o2) => o2.value === v2)).filter(isNonNullable),
    {
      action: "select-option",
      option: void 0,
      name: props.name
    }
  ) ?? (() => {
  });
  const avaliableValues = values?.filter((v2) => flatedOptionValues.includes(v2));
  return /* @__PURE__ */ jsx46(Wrapper, { values: values ?? [], onChange, children: /* @__PURE__ */ jsx46(
    BaseSelect,
    {
      isMulti: true,
      ...props,
      value: isSortable ? avaliableValues?.map((v2) => flatedOptions.find((o2) => o2.value === v2)).filter(isNonNullable) ?? [] : flatedOptions.filter((o2) => values?.includes(o2.value)),
      components: {
        MultiValue: isSortable ? SortableItem : components3.MultiValue
      }
    }
  ) });
};
var flatOptions2 = (options) => {
  return options.flatMap((o2) => {
    switch (o2.type) {
      case "group":
        return o2.options;
      case "item":
        return [o2];
    }
  });
};
var SortableWrapper = ({
  children,
  values,
  onChange
}) => {
  const sensors = useSensors(useSensor(PointerSensor));
  return /* @__PURE__ */ jsx46(
    DndContext,
    {
      sensors,
      onDragEnd: ({ active, over }) => {
        if (!over || active.id === over.id) return;
        const oldIndex = values.findIndex((item) => item === active.id);
        const newIndex = values.findIndex((item) => item === over.id);
        const reordered = [...values];
        const [moved] = reordered.splice(oldIndex, 1);
        reordered.splice(newIndex, 0, moved);
        onChange(reordered);
      },
      children: /* @__PURE__ */ jsx46(SortableContext, { items: values, children })
    }
  );
};
var SortableItem = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props.data.value
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: "inline-block",
    marginRight: 4
  };
  return /* @__PURE__ */ jsx46("div", { ref: setNodeRef, style, ...attributes, ...listeners, children: /* @__PURE__ */ jsx46(components3.MultiValue, { ...props }) });
};

// lib/components/select/single-select/single-select.tsx
import { jsx as jsx47 } from "@emotion/react/jsx-runtime";
var SingleSelect = ({
  value,
  onChange,
  required = false,
  ...props
}) => {
  return /* @__PURE__ */ jsx47(
    BaseSelect,
    {
      ...props,
      value: flatOptions3(props.options ?? []).find((o2) => o2.value === value),
      isClearable: !required,
      onChange: (newValue, actionMeta) => {
        if (required && isNullable(newValue)) {
          return;
        }
        onChange?.(newValue ?? void 0, actionMeta);
      }
    }
  );
};
var flatOptions3 = (options) => {
  return options.flatMap((o2) => {
    switch (o2.type) {
      case "group":
        return o2.options;
      case "item":
        return [o2];
    }
  });
};

// lib/components/table/sortable-th/sortable-th.tsx
import { useState as useState7 } from "react";
import { jsx as jsx48, jsxs as jsxs28 } from "@emotion/react/jsx-runtime";
var SortableTh = ({
  label,
  sortDirection,
  onClick
}) => {
  const { hovering, hoverSensor } = useHover();
  const [ref, setRef] = useState7(null);
  return /* @__PURE__ */ jsxs28("th", { children: [
    /* @__PURE__ */ jsxs28(
      "button",
      {
        onClick,
        className: "is-clickable",
        style: { background: "none", border: "none" },
        ref: setRef,
        ...hoverSensor,
        children: [
          sortDirection === "asc" ? /* @__PURE__ */ jsx48("i", { className: "fa-solid fa-caret-up" }) : sortDirection === "desc" ? /* @__PURE__ */ jsx48("i", { className: "fa-solid fa-caret-down" }) : /* @__PURE__ */ jsx48("i", { className: "fa-solid fa-sort", style: { color: "#999fa3" } }),
          /* @__PURE__ */ jsx48(
            "span",
            {
              style: {
                fontSize: "1rem",
                fontWeight: "bold",
                marginLeft: "0.5rem"
              },
              children: label
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx48(
      Tooltips,
      {
        isActive: hovering,
        refElement: ref,
        label: `${label}\u9806\u306B\u4E26\u3073\u66FF\u3048`,
        placement: "bottom"
      }
    )
  ] });
};

// lib/components/table/standard-table/standard-table.tsx
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  getPaginationRowModel,
  useReactTable
} from "@tanstack/react-table";
import classnames3 from "classnames";
import React6, { useMemo as useMemo8, useState as useState9 } from "react";

// lib/components/table/standard-table/components/expander-cell.tsx
import { jsx as jsx49 } from "@emotion/react/jsx-runtime";
var ExpanderCell = ({ isExpanded, onClick }) => {
  return /* @__PURE__ */ jsx49(
    "td",
    {
      className: "is-clickable",
      style: {
        padding: 0,
        textAlign: "center",
        verticalAlign: "middle",
        width: 30,
        height: "100%"
      },
      onClick: (e2) => {
        e2.stopPropagation();
        onClick(e2);
      },
      children: /* @__PURE__ */ jsx49(ExpandIcon, { isOpen: !!isExpanded })
    }
  );
};

// lib/components/table/standard-table/components/row.tsx
import { useEffect as useEffect8, useRef as useRef3, useState as useState8 } from "react";
import { Fragment as Fragment15, jsx as jsx50, jsxs as jsxs29 } from "@emotion/react/jsx-runtime";
var Row = ({
  rowData,
  children,
  onClick
}) => {
  const ref = useRef3(null);
  const { hovering, hoverSensor } = useHover();
  const [tooltipVisibility, setTooltipVisibility] = useState8(false);
  const [timeoutId, setTimeoutId] = useState8();
  useEffect8(() => {
    if (hovering) {
      const id = setTimeout(() => {
        setTooltipVisibility(true);
      }, 1e3);
      setTimeoutId(id);
      return;
    }
    if (timeoutId !== void 0) {
      clearTimeout(timeoutId);
      setTimeoutId(void 0);
    }
    setTooltipVisibility(false);
  }, [hovering]);
  return /* @__PURE__ */ jsxs29(
    "tr",
    {
      ...hoverSensor,
      ref,
      onClick: (e2) => {
        if (onClick) onClick(e2, rowData);
      },
      style: { cursor: onClick ? "pointer" : void 0 },
      children: [
        children,
        /* @__PURE__ */ jsx50(
          Tooltips,
          {
            placement: "top-start",
            refElement: ref.current,
            isActive: tooltipVisibility,
            cursor: true,
            label: /* @__PURE__ */ jsx50(Fragment15, { children: "\u30AF\u30EA\u30C3\u30AF\u3067\u8A73\u7D30\u8868\u793A" }),
            subLabel: /* @__PURE__ */ jsx50("div", { children: /* @__PURE__ */ jsx50("div", { children: "\u30B7\u30D5\u30C8\u3068\u30AF\u30EA\u30C3\u30AF\u3067\u9078\u629E" }) })
          }
        )
      ]
    }
  );
};

// lib/components/table/standard-table/standard-table.tsx
import { jsx as jsx51, jsxs as jsxs30 } from "@emotion/react/jsx-runtime";
var StandardTable = ({
  className,
  data,
  columns: cols,
  highlightedId,
  stickyHeader,
  pagination,
  check,
  dragSort,
  expand,
  onClickRow
}) => {
  const { checkedItems = /* @__PURE__ */ new Set(), onChangeHeader, onChangeRow } = check || {};
  const { isDragging = false, onDragged = () => {
  } } = dragSort || {};
  const { initialExpandeds = {}, expandableItems = /* @__PURE__ */ new Set() } = expand || {};
  const { index = 0, perPage = 0 } = pagination || {};
  const columnHelper = useMemo8(() => createColumnHelper(), []);
  const [expanded, setExpanded] = useState9(initialExpandeds);
  const columns = useMemo8(() => {
    return [
      ...expand ? [
        columnHelper.display({
          id: "_expand",
          cell: (vv) => vv.row.getCanExpand() ? /* @__PURE__ */ jsx51(
            ExpanderCell,
            {
              isExpanded: vv.row.getIsExpanded(),
              onClick: vv.row.getToggleExpandedHandler()
            },
            vv.cell.id
          ) : void 0
        })
      ] : [],
      ...check ? [
        columnHelper.display({
          id: "_check",
          header: (vv) => {
            const rows = vv.table.getRowModel().flatRows;
            const isChecked = rows.length > 0 && rows.every((v2) => checkedItems.has(v2.id));
            return !isDragging ? /* @__PURE__ */ jsx51(
              CheckCell,
              {
                As: "th",
                checked: isChecked,
                onChange: (e2) => {
                  if (onChangeHeader) {
                    onChangeHeader(
                      e2,
                      !isChecked,
                      vv.table.getRowModel().flatRows.map((v2) => v2.original)
                    );
                  }
                },
                tips: {
                  label: isChecked ? "\u5168\u89E3\u9664" : "\u5168\u9078\u629E"
                }
              },
              vv.header.column.id
            ) : void 0;
          },
          cell: (vv) => {
            const isChecked = checkedItems.has(vv.row.original.id);
            return isDragging ? void 0 : /* @__PURE__ */ jsx51(
              CheckCell,
              {
                As: "td",
                className: classnames3(
                  vv.row.original.id === highlightedId && "is-selected",
                  "is-clickable"
                ),
                checked: isChecked,
                onChange: (e2) => onChangeRow && onChangeRow(e2.nativeEvent, !isChecked, vv.row.original),
                tips: { label: isChecked ? "\u89E3\u9664" : "\u9078\u629E" }
              },
              vv.cell.id
            );
          }
        })
      ] : [],
      ...toHelperObject(columnHelper, cols, highlightedId)
    ];
  }, [
    expand,
    columnHelper,
    check,
    cols,
    highlightedId,
    isDragging,
    checkedItems,
    onChangeHeader,
    onChangeRow
  ]);
  const table = useReactTable({
    data,
    columns,
    state: {
      pagination: {
        pageIndex: index,
        pageSize: perPage
      },
      expanded
    },
    manualPagination: !pagination,
    paginateExpandedRows: false,
    onExpandedChange: setExpanded,
    getRowId: (row) => row.id,
    getRowCanExpand: (row) => expandableItems.has(row.original.id),
    //getSubRows: (row) => row.children,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getExpandedRowModel: getExpandedRowModel()
  });
  const handleClickRow = (e2, row) => {
    if (e2.shiftKey) {
      if (onChangeRow)
        onChangeRow(e2.nativeEvent, !checkedItems.has(row.id), row);
      return;
    }
    if (onClickRow) onClickRow(row);
  };
  const elRows = table.getRowModel().rows.map((row) => {
    const elCells = row.getVisibleCells().map((cell) => /* @__PURE__ */ jsx51(React6.Fragment, { children: flexRender(cell.column.columnDef.cell, cell.getContext()) }, cell.id));
    return /* @__PURE__ */ jsxs30(React6.Fragment, { children: [
      isDragging ? /* @__PURE__ */ jsx51(
        DndRow,
        {
          rowData: row.original,
          onClick: (_2, row2) => {
            if (onClickRow) onClickRow(row2);
          },
          children: elCells
        },
        row.id
      ) : /* @__PURE__ */ jsx51(Row, { rowData: row.original, onClick: handleClickRow, children: elCells }, row.id),
      row.getIsExpanded() && /* @__PURE__ */ jsx51(
        "tr",
        {
          style: {
            background: "#FAFAFA"
          },
          children: /* @__PURE__ */ jsx51("td", { colSpan: row.getAllCells().length })
        },
        row.id + "_expand"
      )
    ] }, row.id);
  });
  return /* @__PURE__ */ jsxs30("table", { className, children: [
    /* @__PURE__ */ jsx51("tbody", { children: isDragging ? /* @__PURE__ */ jsx51(Draggable, { items: data, onDragged, children: elRows }) : elRows }),
    /* @__PURE__ */ jsx51(
      "thead",
      {
        style: stickyHeader ? {
          position: "sticky",
          top: stickyHeader
        } : {},
        children: table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ jsx51("tr", { children: headerGroup.headers.map(
          (header) => header.column.id === "_check" ? (
            //TODO: CheckCellがthを含んでしまうため暫定処置。汎用CheckBox componentを用意して切り替える。
            /* @__PURE__ */ jsx51(React6.Fragment, { children: flexRender(
              header.column.columnDef.header,
              header.getContext()
            ) }, header.column.id)
          ) : /* @__PURE__ */ jsx51("th", { children: header.isPlaceholder ? void 0 : flexRender(
            header.column.columnDef.header,
            header.getContext()
          ) }, header.column.id)
        ) }, headerGroup.id))
      }
    )
  ] });
};
var toHelperObject = (columnHelper, columns, highlightedId) => {
  return columns.map((v2) => {
    switch (v2.type) {
      default:
      case "string":
        return columnHelper.display({
          ...v2,
          cell: (vv) => /* @__PURE__ */ jsx51(
            NoDataFiller,
            {
              className: classnames3(
                vv.row.id === highlightedId && "is-selected",
                "is-clickable"
              ),
              children: v2.cell(vv.row.original)
            },
            vv.cell.id
          )
        });
      case "custom":
        return columnHelper.display({
          ...v2,
          cell: (vv) => /* @__PURE__ */ jsx51(
            NoDataFiller,
            {
              className: classnames3(
                vv.row.id === highlightedId && "is-selected",
                "is-clickable"
              ),
              children: v2.cell(vv.row.original)
            },
            vv.cell.id
          )
        });
    }
  });
};

// lib/components/toggle/switch-box-button/switch-box-button.tsx
import classnames4 from "classnames";
import { useState as useState10 } from "react";
import { Fragment as Fragment16, jsx as jsx52, jsxs as jsxs31 } from "@emotion/react/jsx-runtime";
var SwitchBoxButton = ({
  classNames: classNames11,
  style: customStyle,
  value,
  label,
  color,
  onChange,
  tips
}) => {
  const { hoverSensor, hovering } = useHover();
  const [ref, setRef] = useState10(null);
  const mode = value ? "on" : !hovering ? "off" : "offHover";
  const style = matchType(mode, {
    on: {
      color: "#FFFFFF",
      borderColor: color,
      backgroundColor: color
    },
    off: {
      color: "#999FA3",
      borderColor: "#B3B7BA",
      backgroundColor: "#F2F3F4"
    },
    offHover: {
      color,
      borderColor: color,
      backgroundColor: "#FFFFFF"
    }
  });
  return /* @__PURE__ */ jsxs31(Fragment16, { children: [
    /* @__PURE__ */ jsxs31(
      "label",
      {
        className: classnames4("px-1", classNames11),
        onClick: (e2) => {
          e2.stopPropagation();
        },
        style: {
          ...customStyle,
          display: "inline-flex",
          alignItems: "center",
          border: "solid 2px",
          borderRadius: "4px",
          cursor: "pointer",
          transition: "border 0.1s ease-in, background 0.1s ease-in, color 0.1s ease-in",
          ...style
        },
        ref: setRef,
        ...hoverSensor,
        children: [
          /* @__PURE__ */ jsx52(
            "input",
            {
              type: "checkbox",
              checked: value,
              onChange: (e2) => {
                onChange && onChange(e2.target.checked);
              },
              style: {
                display: "none"
              }
            }
          ),
          /* @__PURE__ */ jsx52("span", { className: "icon is-small", children: /* @__PURE__ */ jsx52(
            "i",
            {
              className: `${value ? "far fa-circle-check" : "far fa-circle-stop"}`
            }
          ) }),
          /* @__PURE__ */ jsx52(
            "span",
            {
              className: "pl-1",
              style: { fontSize: "0.8em", fontWeight: "600", userSelect: "none" },
              children: value ? label.on : label.off
            }
          )
        ]
      }
    ),
    tips && /* @__PURE__ */ jsx52(Tooltips, { isActive: hovering, refElement: ref, ...tips })
  ] });
};

// lib/components/button/base-button.tsx
import { Fragment as Fragment17, jsx as jsx53, jsxs as jsxs32 } from "@emotion/react/jsx-runtime";
var BaseButton = forwardRef7(
  ({ tips, type = "button", ...props }, innerRef) => {
    const { hovering, hoverSensor } = useHover();
    const [ref, setRef] = useState11(null);
    return /* @__PURE__ */ jsxs32(Fragment17, { children: [
      /* @__PURE__ */ jsx53(
        "button",
        {
          ...props,
          ...hoverSensor,
          type,
          className: classNames10("button", props.className),
          ref: (r2) => {
            setRef(r2);
            if (isNonNullable(innerRef)) {
              if (typeof innerRef === "function") {
                innerRef(r2);
              } else {
                innerRef.current = r2;
              }
            }
          }
        }
      ),
      tips && /* @__PURE__ */ jsx53(Tooltips, { isActive: hovering, refElement: ref, ...tips })
    ] });
  }
);
BaseButton.displayName = "BaseButton";

export {
  BaseButton,
  Button,
  SubmitButton,
  CheckCell,
  TextInput,
  SearchInput,
  BaseExpandableRangePicker,
  BasePicker,
  DatePicker,
  DateTimePicker,
  LocalDatePicker,
  LocalDateTimePicker,
  LocalTimePicker,
  RelativeLocalDateTimePicker,
  YearMonthDatePicker,
  YearMonthPicker,
  DeniedByPolicyIcon,
  BaseDropdown,
  Dropdown,
  DropdownTitleItem,
  DropdownSectionHeaderItem,
  DropdownOptionItem,
  DropdownBlockItem,
  DropdownDivider,
  FormField,
  FormSingleTextAreaField,
  FormSingleTextField,
  FormChip,
  NotSelectedValue,
  NotSelectedOption,
  SelectOption,
  MultiSelectInputLabel,
  MultiSelectInput,
  SelectInput,
  TermInputItem,
  TermInput,
  FormChipInputSelector,
  FormChipList,
  FrameTypeSwitch,
  TitledList,
  BaseModal,
  ConfirmDialog,
  GuideDialog,
  CheckListItem,
  FavoriteListItem,
  SearchConditionPanel,
  SearchPanel,
  CreatableStyledSelect,
  BaseCreatableSelect,
  StyledSelect,
  BaseSelect,
  CreatableMultiSelect,
  MultiSelect,
  SingleSelect,
  SortableTh,
  ExpanderCell,
  Row,
  StandardTable,
  SwitchBoxButton
};
